var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "450px",
    height: "220px",
    viewBox: "74 120 129 39",
    id: "svg14513",
    xmlns: "http://www.w3.org/2000/svg",
    svg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs14510"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17048"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#074e9c",
      strokeWidth: 0.578164,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect294183-6",
    width: 81.679405,
    height: 49.398621,
    x: 97.665108,
    y: 111.66367
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\u0413\\u041E\\u0421\\u0423\\u0414\\u0410\\u0420\\u0421\\u0422\\u0412\\u0415\\u041D\\u041D\\u041E\\u0415 \\u0423\\u0427\\u0420\\u0415\\u0416\\u0415\\u041D\\u0418\\u0415 \\u0423\\u041F\\u0420\\u0410\\u0412\\u041B\\u0415\\u041D\\u0418\\u042F \\u0417\\u0414\\u0420\\u0410\\u0412\\u041E\\u041E\\u0425\\u0420\\u0410\\u041D\\u0415\\u041D\\u0418\\u042F \\u0420\\u041E\\u0421\\u0421\\u0418\\u0419\\u0421\\u041A\\u041E\\u0419 \\u0424\\u0415\\u0414\\u0415\\u0420\\u0410\\u0426\\u0418\\u0418 \\u0413. \\u041A\\u0420\\u0410\\u0421\\u041D\\u041E\\u0414\\u0410\\u0420 \"\\u0413\\u041E\\u0420\\u041E\\u0414\\u0421\\u041A\\u0410\\u042F \\u041F\\u041E\\u041B\\u0418\\u041A\\u041B\\u0418\\u041D\\u0418\\u041A\\u0410 \\u211600\" ",
    transform: "scale(1.0094153,0.99067252)",
    id: "text297325-5",
    style: {
      fontSize: "5.06957px",
      lineHeight: 0,
      display: "inline",
      fill: "#074e9c",
      strokeWidth: 0.190108
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 106.65452,115.46872 h 0.46326 v 3.41923 h -0.46326 z m 0.26808,0 h 1.29338 v 0.43975 h -1.29338 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 109.55124,118.92322 q -0.31041,0 -0.54087,-0.12699 -0.23046,-0.12933 -0.35509,-0.36449 -0.12229,-0.23752 -0.12229,-0.55968 v -1.38745 q 0,-0.32217 0.12229,-0.55968 0.12463,-0.23751 0.35509,-0.3645 0.23046,-0.12699 0.54087,-0.12699 0.31041,0 0.54087,0.12699 0.23045,0.12699 0.35274,0.3645 0.12463,0.23751 0.12463,0.55968 v 1.38745 q 0,0.32216 -0.12463,0.55968 -0.12229,0.23516 -0.35274,0.36449 -0.23046,0.12699 -0.54087,0.12699 z m 0,-0.45386 q 0.16696,0 0.2916,-0.0705 0.12463,-0.0705 0.19048,-0.20223 0.0682,-0.13169 0.0682,-0.31042 v -1.41566 q 0,-0.17872 -0.0682,-0.31041 -0.0658,-0.13169 -0.19048,-0.20224 -0.12464,-0.0705 -0.2916,-0.0705 -0.16697,0 -0.2916,0.0705 -0.12464,0.0706 -0.19283,0.20224 -0.0658,0.13169 -0.0658,0.31041 v 1.41566 q 0,0.17873 0.0658,0.31042 0.0682,0.13169 0.19283,0.20223 0.12463,0.0705 0.2916,0.0705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 112.04584,118.92322 q -0.30101,0 -0.52441,-0.12934 -0.22105,-0.12934 -0.34098,-0.3692 -0.11993,-0.24221 -0.11993,-0.56909 v -1.35217 q 0,-0.32922 0.11993,-0.56908 0.11993,-0.24222 0.34098,-0.37156 0.2234,-0.12934 0.52441,-0.12934 0.2916,0 0.50324,0.11758 0.21164,0.11758 0.33158,0.34569 0.12228,0.22811 0.14344,0.55498 v 0 h -0.47032 v 0 q -0.0165,-0.18108 -0.0823,-0.30806 -0.0658,-0.12699 -0.17637,-0.19283 -0.10818,-0.0658 -0.24927,-0.0658 -0.15756,0 -0.27279,0.0752 -0.11523,0.0752 -0.17872,0.214 -0.0635,0.13874 -0.0635,0.32922 v 1.35217 q 0,0.18813 0.0635,0.32923 0.0635,0.13874 0.17872,0.21399 0.11523,0.0729 0.27279,0.0729 0.14109,0 0.24927,-0.0635 0.11052,-0.0635 0.17637,-0.19048 0.0658,-0.12699 0.0823,-0.31276 v 0 h 0.47032 v 0 q -0.0212,0.32687 -0.14344,0.55498 -0.11994,0.2281 -0.33158,0.34568 -0.21164,0.11758 -0.50324,0.11758 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 113.37639,115.46872 h 0.50795 l 0.73605,2.50916 -0.29865,0.38331 z m 1.43448,2.77254 q -0.0682,0.2281 -0.17402,0.3786 -0.10347,0.15051 -0.25397,0.22811 -0.1505,0.0752 -0.35509,0.0752 h -0.29866 v -0.45856 h 0.29866 q 0.10112,0 0.17872,-0.047 0.0776,-0.047 0.13404,-0.1364 0.0588,-0.0894 0.0964,-0.22575 l 0.70548,-2.58676 h 0.48443 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 115.47827,118.4482 h 0.04 q 0.2234,0 0.34569,-0.20224 0.12228,-0.20224 0.12228,-0.56909 v -2.20815 h 0.46327 v 2.25048 q 0,0.32452 -0.10583,0.55498 -0.10347,0.23046 -0.301,0.35274 -0.19754,0.11993 -0.47738,0.11993 h -0.087 z m -0.0353,0 h 0.46327 v 1.14758 H 115.443 Z m 0,0 h 2.44331 v 0.43975 H 115.443 Z m 2.23167,0 h 0.46327 v 1.14758 h -0.46327 z m -0.39742,-2.97948 h 0.46327 v 3.41923 h -0.46327 z m -0.99238,0 h 1.20638 v 0.43975 h -1.20638 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 119.50612,115.46872 h 0.40918 l 1.01589,3.41923 h -0.49854 l -0.72194,-2.73727 -0.7243,2.73727 h -0.49618 z m -0.47503,2.23402 h 1.3898 v 0.4374 h -1.3898 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 121.58683,117.12189 h 0.86304 q 0.12229,0 0.21165,-0.0564 0.0917,-0.0564 0.14109,-0.16226 0.0494,-0.10583 0.0494,-0.24692 v -0.27279 q 0,-0.1458 -0.0494,-0.25162 -0.0494,-0.10817 -0.14109,-0.16461 -0.0894,-0.0588 -0.21165,-0.0588 h -0.86304 v -0.43975 h 0.84893 q 0.27279,0 0.47267,0.11052 0.20224,0.11053 0.30806,0.31747 0.10818,0.20459 0.10818,0.48208 v 0.28219 q 0,0.27749 -0.10818,0.47973 -0.10817,0.20223 -0.30806,0.31276 -0.19988,0.10817 -0.47267,0.10817 h -0.84893 z m -0.24691,-1.65317 h 0.46326 v 3.41923 h -0.46326 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 124.77986,118.92322 q -0.30101,0 -0.52441,-0.12934 -0.22105,-0.12934 -0.34098,-0.3692 -0.11993,-0.24221 -0.11993,-0.56909 v -1.35217 q 0,-0.32922 0.11993,-0.56908 0.11993,-0.24222 0.34098,-0.37156 0.2234,-0.12934 0.52441,-0.12934 0.2916,0 0.50324,0.11758 0.21165,0.11758 0.33158,0.34569 0.12228,0.22811 0.14345,0.55498 v 0 h -0.47032 v 0 q -0.0165,-0.18108 -0.0823,-0.30806 -0.0658,-0.12699 -0.17637,-0.19283 -0.10817,-0.0658 -0.24927,-0.0658 -0.15756,0 -0.27279,0.0752 -0.11523,0.0752 -0.17872,0.214 -0.0635,0.13874 -0.0635,0.32922 v 1.35217 q 0,0.18813 0.0635,0.32923 0.0635,0.13874 0.17872,0.21399 0.11523,0.0729 0.27279,0.0729 0.1411,0 0.24927,-0.0635 0.11052,-0.0635 0.17637,-0.19048 0.0658,-0.12699 0.0823,-0.31276 v 0 h 0.47032 v 0 q -0.0212,0.32687 -0.14345,0.55498 -0.11993,0.2281 -0.33158,0.34568 -0.21164,0.11758 -0.50324,0.11758 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 126.73829,115.74856 h 0.46327 v 3.13939 h -0.46327 z m -0.78073,-0.27984 h 2.02238 v 0.43975 h -2.02238 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 128.6591,118.45525 h 0.7384 q 0.25163,0 0.37626,-0.10582 0.12463,-0.10582 0.12463,-0.29865 v -0.23751 q 0,-0.15051 -0.0517,-0.25633 -0.0517,-0.10817 -0.15285,-0.16461 -0.10112,-0.0588 -0.25163,-0.0588 h -0.78308 v -0.42799 h 0.78308 q 0.19989,0 0.30571,-0.10818 0.10582,-0.11052 0.10582,-0.31981 v -0.18108 q 0,-0.19518 -0.11287,-0.29395 -0.11288,-0.10112 -0.32923,-0.10112 h -0.75251 v -0.43269 h 0.79014 q 0.28219,0 0.47737,0.0964 0.19519,0.0941 0.2916,0.27514 0.0988,0.17872 0.0988,0.42799 v 0.19048 q 0,0.16697 -0.0588,0.30571 -0.0588,0.13875 -0.17872,0.23281 -0.11758,0.0941 -0.2869,0.12699 0.17637,0.0259 0.30571,0.12463 0.12934,0.0988 0.19518,0.25162 0.0682,0.1505 0.0682,0.33863 v 0.23751 q 0,0.24927 -0.10347,0.4327 -0.10112,0.18342 -0.2963,0.28219 -0.19518,0.0964 -0.45856,0.0964 h -0.84423 z m -0.28219,-2.98653 h 0.46326 v 3.41923 h -0.46326 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 130.92089,115.46872 h 0.46327 v 3.41923 h -0.46327 z m 0.23281,2.97948 h 1.58498 v 0.43975 h -1.58498 z m 0,-1.47681 h 1.3992 v 0.4374 h -1.3992 z m 0,-1.50267 h 1.58498 v 0.43975 h -1.58498 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 134.77001,115.46872 h 0.46327 v 3.41923 h -0.46327 z m -1.51913,0 h 0.46561 v 3.41923 h -0.46561 z m 0.29865,1.51678 h 1.45799 v 0.4374 h -1.45799 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 137.40571,115.46872 h 0.46326 v 3.41923 h -0.46326 z m -1.51914,0 h 0.46562 v 3.41923 h -0.46562 z m 0.29866,1.51678 h 1.45799 v 0.4374 h -1.45799 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 139.50759,118.92322 q -0.31041,0 -0.54087,-0.12699 -0.23046,-0.12933 -0.35509,-0.36449 -0.12228,-0.23752 -0.12228,-0.55968 v -1.38745 q 0,-0.32217 0.12228,-0.55968 0.12463,-0.23751 0.35509,-0.3645 0.23046,-0.12699 0.54087,-0.12699 0.31041,0 0.54087,0.12699 0.23045,0.12699 0.35274,0.3645 0.12463,0.23751 0.12463,0.55968 v 1.38745 q 0,0.32216 -0.12463,0.55968 -0.12229,0.23516 -0.35274,0.36449 -0.23046,0.12699 -0.54087,0.12699 z m 0,-0.45386 q 0.16696,0 0.2916,-0.0705 0.12463,-0.0705 0.19048,-0.20223 0.0682,-0.13169 0.0682,-0.31042 v -1.41566 q 0,-0.17872 -0.0682,-0.31041 -0.0658,-0.13169 -0.19048,-0.20224 -0.12464,-0.0705 -0.2916,-0.0705 -0.16697,0 -0.2916,0.0705 -0.12463,0.0706 -0.19283,0.20224 -0.0658,0.13169 -0.0658,0.31041 v 1.41566 q 0,0.17873 0.0658,0.31042 0.0682,0.13169 0.19283,0.20223 0.12463,0.0705 0.2916,0.0705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 141.09682,115.46872 h 0.46327 v 3.41923 h -0.46327 z m 0.23281,2.97948 h 1.58498 v 0.43975 h -1.58498 z m 0,-1.47681 h 1.3992 v 0.4374 h -1.3992 z m 0,-1.50267 h 1.58498 v 0.43975 h -1.58498 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 144.35759,115.46872 h 0.50795 l 0.73605,2.50916 -0.29866,0.38331 z m 1.43448,2.77254 q -0.0682,0.2281 -0.17402,0.3786 -0.10347,0.15051 -0.25397,0.22811 -0.15051,0.0752 -0.3551,0.0752 h -0.29865 v -0.45856 h 0.29865 q 0.10112,0 0.17873,-0.047 0.0776,-0.047 0.13404,-0.1364 0.0588,-0.0894 0.0964,-0.22575 l 0.70548,-2.58676 h 0.48443 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 148.2702,115.46872 h 0.46327 v 3.41923 h -0.46327 z m -0.56908,2.34925 q -0.26338,0 -0.45151,-0.11053 -0.18578,-0.11052 -0.28219,-0.32452 -0.0964,-0.21399 -0.0964,-0.515 v -1.3992 h 0.46092 v 1.40861 q 0,0.23751 0.11758,0.36685 0.11993,0.12934 0.33392,0.12934 0.23281,0 0.3598,-0.1411 0.12698,-0.14345 0.12698,-0.40212 v -0.24222 h 0.15051 v 0.25397 q 0,0.30806 -0.0847,0.52911 -0.0847,0.2187 -0.24692,0.33393 -0.15991,0.11288 -0.38801,0.11288 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 149.63133,117.12189 h 0.86304 q 0.12228,0 0.21164,-0.0564 0.0917,-0.0564 0.1411,-0.16226 0.0494,-0.10583 0.0494,-0.24692 v -0.27279 q 0,-0.1458 -0.0494,-0.25162 -0.0494,-0.10817 -0.1411,-0.16461 -0.0894,-0.0588 -0.21164,-0.0588 h -0.86304 v -0.43975 h 0.84893 q 0.27278,0 0.47267,0.11052 0.20224,0.11053 0.30806,0.31747 0.10817,0.20459 0.10817,0.48208 v 0.28219 q 0,0.27749 -0.10817,0.47973 -0.10817,0.20223 -0.30806,0.31276 -0.19989,0.10817 -0.47267,0.10817 h -0.84893 z m -0.24692,-1.65317 h 0.46327 v 3.41923 h -0.46327 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 151.94251,115.46872 h 0.46326 v 3.41923 h -0.46326 z m 0.2328,2.97948 h 1.58498 v 0.43975 h -1.58498 z m 0,-1.47681 h 1.39921 v 0.4374 h -1.39921 z m 0,-1.50267 h 1.58498 v 0.43975 h -1.58498 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 156.4054,117.02078 0.75016,-1.55206 h 0.52911 l -1.01119,1.95418 z m -0.0141,0.35274 0.40917,-0.23752 1.02765,1.75195 h -0.56908 z m -1.40626,-0.23752 0.40918,0.23752 -0.86774,1.51443 h -0.56909 z m -0.8842,-1.66728 h 0.52911 l 0.75016,1.55206 -0.26573,0.40212 z m 0.88185,1.50267 h 1.82014 v 0.4374 h -1.82014 z m 0.67961,-1.50267 h 0.46091 v 3.41923 h -0.46091 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 158.21097,115.46872 h 0.46327 v 3.41923 h -0.46327 z m 0.23281,2.97948 h 1.58498 v 0.43975 h -1.58498 z m 0,-1.47681 h 1.3992 v 0.4374 h -1.3992 z m 0,-1.50267 h 1.58498 v 0.43975 h -1.58498 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 162.0601,115.46872 h 0.46326 v 3.41923 h -0.46326 z m -1.51914,0 h 0.46562 v 3.41923 h -0.46562 z m 0.29866,1.51678 h 1.45799 v 0.4374 h -1.45799 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 164.81102,118.8856 v -2.58912 l 0.0564,0.0611 -1.30749,2.52798 h -0.38331 v -3.41688 h 0.45386 v 2.61733 l -0.0564,-0.0611 1.31219,-2.55619 h 0.37626 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 165.91582,115.46872 h 0.46327 v 3.41923 h -0.46327 z m 0.23281,2.97948 h 1.58498 v 0.43975 h -1.58498 z m 0,-1.47681 h 1.3992 v 0.4374 h -1.3992 z m 0,-1.50267 h 1.58498 v 0.43975 h -1.58498 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 105.01567,121.00721 h 0.50795 l 0.73605,2.50916 -0.29865,0.38331 z m 1.43448,2.77254 q -0.0682,0.2281 -0.17402,0.37861 -0.10347,0.1505 -0.25397,0.2281 -0.1505,0.0752 -0.35509,0.0752 h -0.29866 v -0.45856 h 0.29866 q 0.10112,0 0.17872,-0.047 0.0776,-0.047 0.13404,-0.13639 0.0588,-0.0894 0.0964,-0.22576 l 0.70548,-2.58676 h 0.48443 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 109.12818,121.00721 h 0.46326 v 3.41923 h -0.46326 z m -1.51914,0 h 0.46327 v 3.41923 h -0.46327 z m 0.29865,0 h 1.458 v 0.43975 h -1.458 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 110.49165,122.66039 h 0.86304 q 0.12228,0 0.21165,-0.0564 0.0917,-0.0564 0.14109,-0.16226 0.0494,-0.10582 0.0494,-0.24692 v -0.27279 q 0,-0.1458 -0.0494,-0.25162 -0.0494,-0.10817 -0.14109,-0.16461 -0.0894,-0.0588 -0.21165,-0.0588 h -0.86304 v -0.43975 h 0.84893 q 0.27279,0 0.47267,0.11053 0.20224,0.11052 0.30806,0.31746 0.10818,0.20459 0.10818,0.48208 v 0.28219 q 0,0.27749 -0.10818,0.47973 -0.10817,0.20224 -0.30806,0.31276 -0.19988,0.10818 -0.47267,0.10818 h -0.84893 z m -0.24691,-1.65318 h 0.46326 v 3.41923 h -0.46326 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 113.36486,121.00721 h 0.40918 l 1.01589,3.41923 h -0.49854 l -0.72194,-2.73727 -0.72429,2.73727 h -0.49619 z m -0.47502,2.23402 h 1.38979 v 0.4374 h -1.38979 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 115.48085,123.99374 h 0.7384 q 0.25163,0 0.37626,-0.10582 0.12464,-0.10582 0.12464,-0.29865 v -0.23751 q 0,-0.15051 -0.0517,-0.25633 -0.0517,-0.10817 -0.15285,-0.16461 -0.10112,-0.0588 -0.25163,-0.0588 h -0.78308 v -0.42799 h 0.78308 q 0.19989,0 0.30571,-0.10817 0.10582,-0.11053 0.10582,-0.31982 v -0.18108 q 0,-0.19518 -0.11287,-0.29395 -0.11288,-0.10111 -0.32923,-0.10111 h -0.75251 v -0.4327 h 0.79014 q 0.28219,0 0.47737,0.0964 0.19519,0.0941 0.2916,0.27513 0.0988,0.17873 0.0988,0.42799 v 0.19048 q 0,0.16697 -0.0588,0.30571 -0.0588,0.13875 -0.17872,0.23281 -0.11758,0.0941 -0.2869,0.12699 0.17637,0.0259 0.30571,0.12463 0.12934,0.0988 0.19518,0.25162 0.0682,0.15051 0.0682,0.33863 v 0.23752 q 0,0.24927 -0.10347,0.43269 -0.10112,0.18343 -0.2963,0.28219 -0.19518,0.0964 -0.45856,0.0964 h -0.84423 z m -0.28219,-2.98653 h 0.46326 v 3.41923 h -0.46326 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 117.61801,123.98904 h 0.002 q 0.14109,0 0.23281,-0.0658 0.0917,-0.0682 0.13639,-0.20459 0.0447,-0.13875 0.0447,-0.35039 v -2.36101 h 0.46327 v 2.36336 q 0,0.35744 -0.0917,0.5926 -0.0917,0.23281 -0.27513,0.34804 -0.18343,0.11523 -0.46327,0.11523 h -0.0494 z m 1.72607,-2.98183 h 0.46327 v 3.41923 h -0.46327 z m -1.01119,0 h 1.24635 v 0.43975 h -1.24635 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 120.45829,121.00721 h 0.46327 v 3.41923 h -0.46327 z m 0.23281,2.97948 h 1.58498 v 0.43975 h -1.58498 z m 0,-1.47681 h 1.3992 v 0.4374 h -1.3992 z m 0,-1.50267 h 1.58498 v 0.43975 h -1.58498 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 124.30741,121.00721 h 0.46327 v 3.41923 h -0.46327 z m -1.51913,0 h 0.46561 v 3.41923 h -0.46561 z m 0.29865,1.51678 h 1.45799 v 0.4374 h -1.45799 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 127.05834,124.42409 v -2.58912 l 0.0564,0.0611 -1.30749,2.52797 h -0.38331 v -3.41688 h 0.45386 v 2.61733 l -0.0564,-0.0611 1.3122,-2.55619 h 0.37625 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16296"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 128.97914,123.05075 q -0.28219,0 -0.49148,-0.10817 -0.20929,-0.11053 -0.32452,-0.31512 -0.11288,-0.20694 -0.11288,-0.48443 v -0.24456 q 0,-0.27279 0.11288,-0.47503 0.11287,-0.20223 0.32217,-0.31041 0.20929,-0.10817 0.49383,-0.10817 h 0.83482 v 0.43975 h -0.86539 q -0.12934,0 -0.2234,0.0588 -0.0941,0.0564 -0.1458,0.16696 -0.0517,0.10818 -0.0517,0.25397 v 0.2187 q 0,0.14345 0.0517,0.24927 0.0517,0.10583 0.1458,0.16226 0.0964,0.0564 0.2234,0.0564 h 0.86539 v 0.43975 z m -0.21634,-0.21399 0.43739,0.10817 -0.63493,1.48151 h -0.52676 z m 0.79719,-1.8319 h 0.46326 v 3.42158 h -0.46326 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 132.71729,124.46171 q -0.32923,0 -0.55263,-0.10347 -0.22105,-0.10347 -0.33863,-0.31746 -0.11523,-0.214 -0.12934,-0.53852 v 0 h 0.46797 v 0 q 0.0165,0.26573 0.15521,0.39272 0.14109,0.12463 0.40918,0.12463 0.23751,0 0.3692,-0.12934 0.13169,-0.13169 0.13169,-0.3692 v -0.19283 q 0,-0.2187 -0.10347,-0.33863 -0.10347,-0.12228 -0.29395,-0.12228 h -0.49854 v -0.4374 h 0.49854 q 0.16226,0 0.25162,-0.10112 0.0894,-0.10112 0.0894,-0.28689 v -0.19989 q 0,-0.20929 -0.11758,-0.31747 -0.11523,-0.11052 -0.32923,-0.11052 -0.23516,0 -0.35979,0.12228 -0.12464,0.11993 -0.14815,0.37155 v 0 h -0.46562 v 0 q 0.0212,-0.31746 0.13404,-0.5244 0.11288,-0.2093 0.32217,-0.31041 0.20929,-0.10112 0.51735,-0.10112 0.2916,0 0.49854,0.0988 0.20694,0.0988 0.31512,0.2916 0.10817,0.19048 0.10817,0.46327 v 0.19753 q 0,0.19519 -0.0988,0.35745 -0.0964,0.1599 -0.27748,0.26102 0.20694,0.0658 0.31981,0.24927 0.11288,0.18108 0.11288,0.44916 v 0.19283 q 0,0.29395 -0.11758,0.50324 -0.11523,0.20694 -0.33628,0.31747 -0.22105,0.10817 -0.53381,0.10817 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 133.92321,123.98669 h 0.04 q 0.2234,0 0.34568,-0.20224 0.12229,-0.20224 0.12229,-0.56909 v -2.20815 h 0.46326 v 2.25048 q 0,0.32452 -0.10582,0.55498 -0.10347,0.23046 -0.30101,0.35274 -0.19753,0.11993 -0.47737,0.11993 h -0.087 z m -0.0353,0 h 0.46326 v 1.14758 h -0.46326 z m 0,0 h 2.44331 v 0.43975 h -2.44331 z m 2.23166,0 h 0.46327 v 1.14758 h -0.46327 z m -0.39742,-2.97948 h 0.46327 v 3.41923 h -0.46327 z m -0.99237,0 h 1.20637 v 0.43975 h -1.20637 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 137.2832,122.66039 h 0.86304 q 0.12228,0 0.21164,-0.0564 0.0917,-0.0564 0.1411,-0.16226 0.0494,-0.10582 0.0494,-0.24692 v -0.27279 q 0,-0.1458 -0.0494,-0.25162 -0.0494,-0.10817 -0.1411,-0.16461 -0.0894,-0.0588 -0.21164,-0.0588 h -0.86304 v -0.43975 h 0.84893 q 0.27278,0 0.47267,0.11053 0.20224,0.11052 0.30806,0.31746 0.10817,0.20459 0.10817,0.48208 v 0.28219 q 0,0.27749 -0.10817,0.47973 -0.10818,0.20224 -0.30806,0.31276 -0.19989,0.10818 -0.47267,0.10818 h -0.84893 z m -0.24692,-1.65318 h 0.46327 v 3.41923 h -0.46327 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 140.15641,121.00721 h 0.40917 l 1.0159,3.41923 h -0.49854 l -0.72195,-2.73727 -0.72429,2.73727 h -0.49619 z m -0.47503,2.23402 h 1.3898 v 0.4374 h -1.3898 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 142.2724,123.99374 h 0.7384 q 0.25162,0 0.37626,-0.10582 0.12463,-0.10582 0.12463,-0.29865 v -0.23751 q 0,-0.15051 -0.0517,-0.25633 -0.0517,-0.10817 -0.15285,-0.16461 -0.10112,-0.0588 -0.25162,-0.0588 h -0.78308 v -0.42799 h 0.78308 q 0.19989,0 0.30571,-0.10817 0.10582,-0.11053 0.10582,-0.31982 v -0.18108 q 0,-0.19518 -0.11288,-0.29395 -0.11287,-0.10111 -0.32922,-0.10111 h -0.75251 v -0.4327 h 0.79013 q 0.2822,0 0.47738,0.0964 0.19518,0.0941 0.2916,0.27513 0.0988,0.17873 0.0988,0.42799 v 0.19048 q 0,0.16697 -0.0588,0.30571 -0.0588,0.13875 -0.17873,0.23281 -0.11758,0.0941 -0.28689,0.12699 0.17637,0.0259 0.30571,0.12463 0.12933,0.0988 0.19518,0.25162 0.0682,0.15051 0.0682,0.33863 v 0.23752 q 0,0.24927 -0.10347,0.43269 -0.10112,0.18343 -0.29631,0.28219 -0.19518,0.0964 -0.45856,0.0964 h -0.84422 z m -0.2822,-2.98653 h 0.46327 v 3.41923 h -0.46327 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 145.44896,124.46171 q -0.31041,0 -0.54087,-0.12698 -0.23046,-0.12934 -0.35509,-0.3645 -0.12228,-0.23751 -0.12228,-0.55968 v -1.38745 q 0,-0.32217 0.12228,-0.55968 0.12463,-0.23751 0.35509,-0.3645 0.23046,-0.12698 0.54087,-0.12698 0.31041,0 0.54087,0.12698 0.23045,0.12699 0.35274,0.3645 0.12463,0.23751 0.12463,0.55968 v 1.38745 q 0,0.32217 -0.12463,0.55968 -0.12229,0.23516 -0.35274,0.3645 -0.23046,0.12698 -0.54087,0.12698 z m 0,-0.45386 q 0.16696,0 0.2916,-0.0705 0.12463,-0.0705 0.19048,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41567 q 0,-0.17872 -0.0682,-0.31041 -0.0658,-0.13169 -0.19048,-0.20224 -0.12464,-0.0705 -0.2916,-0.0705 -0.16696,0 -0.2916,0.0705 -0.12463,0.0705 -0.19283,0.20224 -0.0658,0.13169 -0.0658,0.31041 v 1.41567 q 0,0.17872 0.0658,0.31041 0.0682,0.13169 0.19283,0.20224 0.12464,0.0705 0.2916,0.0705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 147.97648,124.46171 q -0.31041,0 -0.54087,-0.12698 -0.23046,-0.12934 -0.35509,-0.3645 -0.12228,-0.23751 -0.12228,-0.55968 v -1.38745 q 0,-0.32217 0.12228,-0.55968 0.12463,-0.23751 0.35509,-0.3645 0.23046,-0.12698 0.54087,-0.12698 0.31041,0 0.54087,0.12698 0.23045,0.12699 0.35274,0.3645 0.12463,0.23751 0.12463,0.55968 v 1.38745 q 0,0.32217 -0.12463,0.55968 -0.12229,0.23516 -0.35274,0.3645 -0.23046,0.12698 -0.54087,0.12698 z m 0,-0.45386 q 0.16696,0 0.2916,-0.0705 0.12463,-0.0705 0.19048,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41567 q 0,-0.17872 -0.0682,-0.31041 -0.0659,-0.13169 -0.19048,-0.20224 -0.12464,-0.0705 -0.2916,-0.0705 -0.16697,0 -0.2916,0.0705 -0.12463,0.0705 -0.19283,0.20224 -0.0659,0.13169 -0.0659,0.31041 v 1.41567 q 0,0.17872 0.0659,0.31041 0.0682,0.13169 0.19283,0.20224 0.12463,0.0705 0.2916,0.0705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 150.26414,122.92847 -0.0753,-0.12228 -0.91948,-1.79898 h 0.50795 l 0.65139,1.38745 0.08,0.13404 0.97826,1.89774 h -0.50794 z m -0.0235,-0.45621 0.68667,-1.46505 h 0.50795 l -0.94299,1.85306 -0.74311,1.56617 h -0.50795 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 152.13086,122.66039 h 0.86304 q 0.12228,0 0.21164,-0.0564 0.0917,-0.0564 0.1411,-0.16226 0.0494,-0.10582 0.0494,-0.24692 v -0.27279 q 0,-0.1458 -0.0494,-0.25162 -0.0494,-0.10817 -0.1411,-0.16461 -0.0894,-0.0588 -0.21164,-0.0588 h -0.86304 v -0.43975 h 0.84893 q 0.27278,0 0.47267,0.11053 0.20224,0.11052 0.30806,0.31746 0.10817,0.20459 0.10817,0.48208 v 0.28219 q 0,0.27749 -0.10817,0.47973 -0.10817,0.20224 -0.30806,0.31276 -0.19989,0.10818 -0.47267,0.10818 h -0.84893 z m -0.24692,-1.65318 h 0.46327 v 3.41923 h -0.46327 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 155.00407,121.00721 h 0.40917 l 1.0159,3.41923 h -0.49854 l -0.72195,-2.73727 -0.72429,2.73727 h -0.49619 z m -0.47503,2.23402 h 1.3898 v 0.4374 h -1.3898 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 158.357,121.00721 h 0.46326 v 3.41923 H 158.357 Z m -1.51914,0 h 0.46562 v 3.41923 h -0.46562 z m 0.29866,1.51678 h 1.45799 v 0.4374 h -1.45799 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 159.47356,121.00721 h 0.46327 v 3.41923 h -0.46327 z m 0.23281,2.97948 h 1.58498 v 0.43975 h -1.58498 z m 0,-1.47681 h 1.3992 v 0.4374 h -1.3992 z m 0,-1.50267 h 1.58498 v 0.43975 h -1.58498 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 163.32268,121.00721 h 0.46327 v 3.41923 h -0.46327 z m -1.51913,0 h 0.46561 v 3.41923 h -0.46561 z m 0.29865,1.51678 h 1.45799 v 0.4374 h -1.45799 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 166.0736,124.42409 v -2.58912 l 0.0564,0.0611 -1.30749,2.52797 h -0.38331 v -3.41688 h 0.45386 v 2.61733 l -0.0564,-0.0611 1.31219,-2.55619 h 0.37626 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 167.99441,123.05075 q -0.28219,0 -0.49148,-0.10817 -0.2093,-0.11053 -0.32452,-0.31512 -0.11288,-0.20694 -0.11288,-0.48443 v -0.24456 q 0,-0.27279 0.11288,-0.47503 0.11287,-0.20223 0.32217,-0.31041 0.20929,-0.10817 0.49383,-0.10817 h 0.83482 v 0.43975 h -0.86539 q -0.12934,0 -0.2234,0.0588 -0.0941,0.0564 -0.1458,0.16696 -0.0517,0.10818 -0.0517,0.25397 v 0.2187 q 0,0.14345 0.0517,0.24927 0.0517,0.10583 0.1458,0.16226 0.0964,0.0564 0.2234,0.0564 h 0.86539 v 0.43975 z m -0.21635,-0.21399 0.4374,0.10817 -0.63493,1.48151 h -0.52676 z m 0.7972,-1.8319 h 0.46326 v 3.42158 h -0.46326 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 98.279913,128.19888 h 0.863037 q 0.122284,0 0.211645,-0.0564 0.09171,-0.0564 0.141096,-0.16226 0.04938,-0.10582 0.04938,-0.24692 v -0.27278 q 0,-0.1458 -0.04938,-0.25163 -0.04938,-0.10817 -0.141096,-0.16461 -0.08936,-0.0588 -0.211645,-0.0588 h -0.863037 v -0.43975 h 0.848928 q 0.272786,0 0.472672,0.11053 0.202238,0.11052 0.30806,0.31746 0.108177,0.20459 0.108177,0.48208 v 0.28219 q 0,0.27749 -0.108177,0.47973 -0.108174,0.20224 -0.30806,0.31276 -0.199886,0.10818 -0.472672,0.10818 h -0.848928 z m -0.246918,-1.65318 h 0.463265 v 3.41923 h -0.463265 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 101.50586,130.00021 q -0.31041,0 -0.54087,-0.12699 -0.23046,-0.12934 -0.35509,-0.3645 -0.12228,-0.23751 -0.12228,-0.55968 v -1.38745 q 0,-0.32217 0.12228,-0.55968 0.12463,-0.23751 0.35509,-0.3645 0.23046,-0.12698 0.54087,-0.12698 0.31041,0 0.54087,0.12698 0.23045,0.12699 0.35274,0.3645 0.12463,0.23751 0.12463,0.55968 v 1.38745 q 0,0.32217 -0.12463,0.55968 -0.12229,0.23516 -0.35274,0.3645 -0.23046,0.12699 -0.54087,0.12699 z m 0,-0.45386 q 0.16696,0 0.2916,-0.0705 0.12463,-0.0705 0.19048,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41567 q 0,-0.17872 -0.0682,-0.31041 -0.0658,-0.13169 -0.19048,-0.20223 -0.12464,-0.0705 -0.2916,-0.0705 -0.16696,0 -0.2916,0.0705 -0.12463,0.0705 -0.19283,0.20223 -0.0658,0.13169 -0.0658,0.31041 v 1.41567 q 0,0.17872 0.0658,0.31041 0.0682,0.13169 0.19283,0.20224 0.12464,0.0705 0.2916,0.0705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 104.00046,130.00021 q -0.30101,0 -0.52441,-0.12934 -0.22105,-0.12934 -0.34098,-0.3692 -0.11993,-0.24222 -0.11993,-0.56909 v -1.35217 q 0,-0.32923 0.11993,-0.56909 0.11993,-0.24222 0.34098,-0.37155 0.2234,-0.12934 0.52441,-0.12934 0.2916,0 0.50324,0.11758 0.21165,0.11758 0.33158,0.34568 0.12228,0.22811 0.14344,0.55498 v 0 h -0.47032 v 0 q -0.0165,-0.18107 -0.0823,-0.30806 -0.0659,-0.12698 -0.17637,-0.19283 -0.10818,-0.0658 -0.24927,-0.0658 -0.15756,0 -0.27279,0.0752 -0.11523,0.0753 -0.17872,0.21399 -0.0635,0.13875 -0.0635,0.32923 v 1.35217 q 0,0.18813 0.0635,0.32922 0.0635,0.13875 0.17872,0.214 0.11523,0.0729 0.27279,0.0729 0.14109,0 0.24927,-0.0635 0.11052,-0.0635 0.17637,-0.19048 0.0658,-0.12698 0.0823,-0.31276 v 0 h 0.47032 v 0 q -0.0212,0.32687 -0.14344,0.55498 -0.11993,0.2281 -0.33158,0.34569 -0.21164,0.11758 -0.50324,0.11758 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 106.38453,130.00021 q -0.301,0 -0.52441,-0.12934 -0.22105,-0.12934 -0.34098,-0.3692 -0.11993,-0.24222 -0.11993,-0.56909 v -1.35217 q 0,-0.32923 0.11993,-0.56909 0.11993,-0.24222 0.34098,-0.37155 0.22341,-0.12934 0.52441,-0.12934 0.2916,0 0.50324,0.11758 0.21165,0.11758 0.33158,0.34568 0.12228,0.22811 0.14345,0.55498 v 0 h -0.47032 v 0 q -0.0165,-0.18107 -0.0823,-0.30806 -0.0658,-0.12698 -0.17637,-0.19283 -0.10817,-0.0658 -0.24927,-0.0658 -0.15756,0 -0.27278,0.0752 -0.11523,0.0753 -0.17873,0.21399 -0.0635,0.13875 -0.0635,0.32923 v 1.35217 q 0,0.18813 0.0635,0.32922 0.0635,0.13875 0.17873,0.214 0.11522,0.0729 0.27278,0.0729 0.1411,0 0.24927,-0.0635 0.11053,-0.0635 0.17637,-0.19048 0.0658,-0.12698 0.0823,-0.31276 v 0 h 0.47032 v 0 q -0.0212,0.32687 -0.14345,0.55498 -0.11993,0.2281 -0.33158,0.34569 -0.21164,0.11758 -0.50324,0.11758 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 109.4976,129.96258 v -2.58911 l 0.0564,0.0611 -1.30749,2.52797 h -0.38331 v -3.41688 h 0.45386 v 2.61733 l -0.0564,-0.0611 1.31219,-2.55619 h 0.37626 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 112.23677,129.96258 v -2.58911 l 0.0564,0.0611 -1.3075,2.52797 h -0.38331 v -3.41688 h 0.45386 v 2.61733 l -0.0564,-0.0611 1.3122,-2.55619 h 0.37625 v 3.41688 z m 0.11052,-4.37868 q 0,0.34098 -0.18342,0.52911 -0.18108,0.18813 -0.515,0.18813 h -0.0188 q -0.33157,0 -0.515,-0.18813 -0.18107,-0.18813 -0.18107,-0.52911 l 0.38801,0.005 q 0,0.17402 0.08,0.27043 0.0799,0.0964 0.2281,0.0964 h 0.0188 q 0.14815,0 0.2281,-0.0964 0.0823,-0.0964 0.0823,-0.27043 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 114.29397,130.00021 q -0.30101,0 -0.52441,-0.12934 -0.22105,-0.12934 -0.34098,-0.3692 -0.11993,-0.24222 -0.11993,-0.56909 v -1.35217 q 0,-0.32923 0.11993,-0.56909 0.11993,-0.24222 0.34098,-0.37155 0.2234,-0.12934 0.52441,-0.12934 0.2916,0 0.50324,0.11758 0.21164,0.11758 0.33158,0.34568 0.12228,0.22811 0.14344,0.55498 v 0 h -0.47032 v 0 q -0.0165,-0.18107 -0.0823,-0.30806 -0.0658,-0.12698 -0.17637,-0.19283 -0.10818,-0.0658 -0.24927,-0.0658 -0.15756,0 -0.27279,0.0752 -0.11523,0.0753 -0.17872,0.21399 -0.0635,0.13875 -0.0635,0.32923 v 1.35217 q 0,0.18813 0.0635,0.32922 0.0635,0.13875 0.17872,0.214 0.11523,0.0729 0.27279,0.0729 0.14109,0 0.24927,-0.0635 0.11052,-0.0635 0.17637,-0.19048 0.0658,-0.12698 0.0823,-0.31276 v 0 h 0.47032 v 0 q -0.0212,0.32687 -0.14344,0.55498 -0.11994,0.2281 -0.33158,0.34569 -0.21164,0.11758 -0.50324,0.11758 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 116.60044,128.09776 0.73605,-1.55206 h 0.52911 l -0.99943,1.95418 z m -0.0141,0.35274 0.40918,-0.23751 1.01354,1.75194 h -0.56909 z m -0.81366,-1.9048 h 0.46327 v 3.41923 h -0.46327 z m 0.23281,1.50268 h 0.99238 v 0.43739 h -0.99238 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 119.1891,130.00021 q -0.31041,0 -0.54087,-0.12699 -0.23045,-0.12934 -0.35509,-0.3645 -0.12228,-0.23751 -0.12228,-0.55968 v -1.38745 q 0,-0.32217 0.12228,-0.55968 0.12464,-0.23751 0.35509,-0.3645 0.23046,-0.12698 0.54087,-0.12698 0.31041,0 0.54087,0.12698 0.23046,0.12699 0.35274,0.3645 0.12464,0.23751 0.12464,0.55968 v 1.38745 q 0,0.32217 -0.12464,0.55968 -0.12228,0.23516 -0.35274,0.3645 -0.23046,0.12699 -0.54087,0.12699 z m 0,-0.45386 q 0.16697,0 0.2916,-0.0705 0.12463,-0.0705 0.19048,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41567 q 0,-0.17872 -0.0682,-0.31041 -0.0659,-0.13169 -0.19048,-0.20223 -0.12463,-0.0705 -0.2916,-0.0705 -0.16696,0 -0.2916,0.0705 -0.12463,0.0705 -0.19283,0.20223 -0.0658,0.13169 -0.0658,0.31041 v 1.41567 q 0,0.17872 0.0658,0.31041 0.0682,0.13169 0.19283,0.20224 0.12464,0.0705 0.2916,0.0705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 122.4127,129.96258 v -2.58911 l 0.0564,0.0611 -1.30749,2.52797 h -0.38331 v -3.41688 h 0.45386 v 2.61733 l -0.0564,-0.0611 1.3122,-2.55619 h 0.37625 v 3.41688 z m 0.11052,-4.37868 q 0,0.34098 -0.18342,0.52911 -0.18108,0.18813 -0.515,0.18813 h -0.0188 q -0.33157,0 -0.515,-0.18813 -0.18107,-0.18813 -0.18107,-0.52911 l 0.38801,0.005 q 0,0.17402 0.08,0.27043 0.08,0.0964 0.2281,0.0964 h 0.0188 q 0.14815,0 0.2281,-0.0964 0.0823,-0.0964 0.0823,-0.27043 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 125.9439,129.60043 q -0.45856,0 -0.78543,-0.14344 -0.32452,-0.14345 -0.49619,-0.42094 -0.16932,-0.27749 -0.16932,-0.67021 v -0.33863 q 0,-0.39272 0.16932,-0.67021 0.17167,-0.27748 0.49619,-0.42093 0.32687,-0.14345 0.78543,-0.14345 0.46092,0 0.78544,0.14345 0.32687,0.14345 0.49618,0.42093 0.16932,0.27749 0.16932,0.67021 v 0.33863 q 0,0.39272 -0.16932,0.67021 -0.16931,0.27749 -0.49618,0.42094 -0.32452,0.14344 -0.78544,0.14344 z m -0.23046,-3.17231 h 0.46327 v 3.53681 h -0.46327 z m 0.23046,2.73491 q 0.47738,0 0.7384,-0.20458 0.26103,-0.20695 0.26103,-0.59261 v -0.33863 q 0,-0.38566 -0.26103,-0.59025 -0.26102,-0.20694 -0.7384,-0.20694 -0.47502,0 -0.7384,0.20694 -0.26103,0.20459 -0.26103,0.59025 v 0.33863 q 0,0.38566 0.26103,0.59261 0.26338,0.20458 0.7384,0.20458 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 127.8506,126.5457 h 0.46326 v 3.41923 h -0.46326 z m 0.23281,2.97948 h 1.58498 v 0.43975 h -1.58498 z m 0,-1.4768 h 1.3992 v 0.43739 h -1.3992 z m 0,-1.50268 h 1.58498 v 0.43975 h -1.58498 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 129.97129,129.52518 h 0.04 q 0.2234,0 0.34569,-0.20224 0.12228,-0.20223 0.12228,-0.56908 v -2.20816 h 0.46326 v 2.25049 q 0,0.32452 -0.10582,0.55497 -0.10347,0.23046 -0.301,0.35274 -0.19754,0.11993 -0.47738,0.11993 h -0.087 z m -0.0353,0 h 0.46326 v 1.14758 h -0.46326 z m 0,0 h 2.44331 v 0.43975 h -2.44331 z m 2.23167,0 h 0.46326 v 1.14758 h -0.46326 z m -0.39742,-2.97948 h 0.46326 v 3.41923 h -0.46326 z m -0.99238,0 h 1.20637 v 0.43975 h -1.20637 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 133.08436,126.5457 h 0.46327 v 3.41923 h -0.46327 z m 0.23281,2.97948 h 1.58498 v 0.43975 h -1.58498 z m 0,-1.4768 h 1.3992 v 0.43739 h -1.3992 z m 0,-1.50268 h 1.58498 v 0.43975 h -1.58498 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 135.66127,128.19888 h 0.86304 q 0.12228,0 0.21164,-0.0564 0.0917,-0.0564 0.1411,-0.16226 0.0494,-0.10582 0.0494,-0.24692 v -0.27278 q 0,-0.1458 -0.0494,-0.25163 -0.0494,-0.10817 -0.1411,-0.16461 -0.0894,-0.0588 -0.21164,-0.0588 h -0.86304 v -0.43975 h 0.84893 q 0.27278,0 0.47267,0.11053 0.20224,0.11052 0.30806,0.31746 0.10817,0.20459 0.10817,0.48208 v 0.28219 q 0,0.27749 -0.10817,0.47973 -0.10818,0.20224 -0.30806,0.31276 -0.19989,0.10818 -0.47267,0.10818 h -0.84893 z m -0.24692,-1.65318 h 0.46327 v 3.41923 h -0.46327 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 138.53447,126.5457 h 0.40918 l 1.01589,3.41923 H 139.461 l -0.72194,-2.73726 -0.72429,2.73726 h -0.49619 z m -0.47502,2.23402 h 1.3898 v 0.4374 h -1.3898 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 141.88976,126.5457 h 0.46327 v 3.41923 h -0.46327 z m -1.22048,2.97948 h 1.63907 v 0.43975 h -1.63907 z m 1.6179,0 h 0.46327 v 1.14758 h -0.46327 z m -1.9189,-2.97948 h 0.46326 v 3.41923 h -0.46326 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 144.83822,129.96258 v -2.58911 l 0.0564,0.0611 -1.30749,2.52797 h -0.38332 v -3.41688 h 0.45386 v 2.61733 l -0.0564,-0.0611 1.31219,-2.55619 h 0.37626 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 147.57738,129.96258 v -2.58911 l 0.0564,0.0611 -1.30749,2.52797 h -0.38331 v -3.41688 h 0.45386 v 2.61733 l -0.0564,-0.0611 1.3122,-2.55619 h 0.37625 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 149.80815,126.5457 h 0.46327 v 3.41923 h -0.46327 z m 0.26809,0 h 1.29338 v 0.43975 h -1.29338 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 151.43736,129.47815 h 0.48678 v 0.48678 h -0.48678 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 154.43475,128.09776 0.73605,-1.55206 h 0.52911 l -0.99943,1.95418 z m -0.0141,0.35274 0.40918,-0.23751 1.01354,1.75194 h -0.56909 z m -0.81365,-1.9048 h 0.46326 v 3.41923 h -0.46326 z m 0.23281,1.50268 h 0.99237 v 0.43739 h -0.99237 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 156.47314,128.19888 h 0.86304 q 0.12228,0 0.21164,-0.0564 0.0917,-0.0564 0.1411,-0.16226 0.0494,-0.10582 0.0494,-0.24692 v -0.27278 q 0,-0.1458 -0.0494,-0.25163 -0.0494,-0.10817 -0.1411,-0.16461 -0.0894,-0.0588 -0.21164,-0.0588 h -0.86304 v -0.43975 h 0.84893 q 0.27279,0 0.47267,0.11053 0.20224,0.11052 0.30806,0.31746 0.10818,0.20459 0.10818,0.48208 v 0.28219 q 0,0.27749 -0.10818,0.47973 -0.10817,0.20224 -0.30806,0.31276 -0.19988,0.10818 -0.47267,0.10818 h -0.84893 z m -0.24692,-1.65318 h 0.46327 v 3.41923 h -0.46327 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 159.34635,126.5457 h 0.40918 l 1.01589,3.41923 h -0.49854 l -0.72194,-2.73726 -0.7243,2.73726 h -0.49618 z m -0.47503,2.23402 h 1.3898 v 0.4374 h -1.3898 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 162.03848,130.00021 q -0.301,0 -0.5244,-0.12934 -0.22106,-0.12934 -0.34099,-0.3692 -0.11993,-0.24222 -0.11993,-0.56909 v -1.35217 q 0,-0.32923 0.11993,-0.56909 0.11993,-0.24222 0.34099,-0.37155 0.2234,-0.12934 0.5244,-0.12934 0.2916,0 0.50325,0.11758 0.21164,0.11758 0.33157,0.34568 0.12228,0.22811 0.14345,0.55498 v 0 h -0.47032 v 0 q -0.0165,-0.18107 -0.0823,-0.30806 -0.0658,-0.12698 -0.17637,-0.19283 -0.10817,-0.0658 -0.24927,-0.0658 -0.15755,0 -0.27278,0.0752 -0.11523,0.0753 -0.17873,0.21399 -0.0635,0.13875 -0.0635,0.32923 v 1.35217 q 0,0.18813 0.0635,0.32922 0.0635,0.13875 0.17873,0.214 0.11523,0.0729 0.27278,0.0729 0.1411,0 0.24927,-0.0635 0.11053,-0.0635 0.17637,-0.19048 0.0658,-0.12698 0.0823,-0.31276 v 0 h 0.47032 v 0 q -0.0212,0.32687 -0.14345,0.55498 -0.11993,0.2281 -0.33157,0.34569 -0.21165,0.11758 -0.50325,0.11758 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 165.03632,126.5457 h 0.46327 v 3.41923 h -0.46327 z m -1.51913,0 h 0.46561 v 3.41923 h -0.46561 z m 0.29865,1.51679 h 1.45799 v 0.43739 h -1.45799 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 167.1382,130.00021 q -0.31041,0 -0.54086,-0.12699 -0.23046,-0.12934 -0.3551,-0.3645 -0.12228,-0.23751 -0.12228,-0.55968 v -1.38745 q 0,-0.32217 0.12228,-0.55968 0.12464,-0.23751 0.3551,-0.3645 0.23045,-0.12698 0.54086,-0.12698 0.31042,0 0.54087,0.12698 0.23046,0.12699 0.35274,0.3645 0.12464,0.23751 0.12464,0.55968 v 1.38745 q 0,0.32217 -0.12464,0.55968 -0.12228,0.23516 -0.35274,0.3645 -0.23045,0.12699 -0.54087,0.12699 z m 0,-0.45386 q 0.16697,0 0.2916,-0.0705 0.12464,-0.0705 0.19048,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41567 q 0,-0.17872 -0.0682,-0.31041 -0.0658,-0.13169 -0.19048,-0.20223 -0.12463,-0.0705 -0.2916,-0.0705 -0.16696,0 -0.29159,0.0705 -0.12464,0.0705 -0.19284,0.20223 -0.0658,0.13169 -0.0658,0.31041 v 1.41567 q 0,0.17872 0.0658,0.31041 0.0682,0.13169 0.19284,0.20224 0.12463,0.0705 0.29159,0.0705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 168.47111,129.52518 h 0.04 q 0.2234,0 0.34568,-0.20224 0.12229,-0.20223 0.12229,-0.56908 v -2.20816 h 0.46326 v 2.25049 q 0,0.32452 -0.10582,0.55497 -0.10347,0.23046 -0.30101,0.35274 -0.19753,0.11993 -0.47737,0.11993 h -0.087 z m -0.0353,0 h 0.46326 v 1.14758 h -0.46326 z m 0,0 h 2.44331 v 0.43975 h -2.44331 z m 2.23167,0 h 0.46326 v 1.14758 h -0.46326 z m -0.39743,-2.97948 h 0.46327 v 3.41923 h -0.46327 z m -0.99237,0 h 1.20637 v 0.43975 h -1.20637 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 172.49896,126.5457 h 0.40917 l 1.0159,3.41923 h -0.49854 l -0.72195,-2.73726 -0.72429,2.73726 h -0.49619 z m -0.47503,2.23402 h 1.3898 v 0.4374 h -1.3898 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 174.57967,128.19888 h 0.86304 q 0.12228,0 0.21164,-0.0564 0.0917,-0.0564 0.1411,-0.16226 0.0494,-0.10582 0.0494,-0.24692 v -0.27278 q 0,-0.1458 -0.0494,-0.25163 -0.0494,-0.10817 -0.1411,-0.16461 -0.0894,-0.0588 -0.21164,-0.0588 h -0.86304 v -0.43975 h 0.84893 q 0.27279,0 0.47267,0.11053 0.20224,0.11052 0.30806,0.31746 0.10818,0.20459 0.10818,0.48208 v 0.28219 q 0,0.27749 -0.10818,0.47973 -0.10817,0.20224 -0.30806,0.31276 -0.19988,0.10818 -0.47267,0.10818 h -0.84893 z m -0.24692,-1.65318 h 0.46327 v 3.41923 h -0.46327 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 104.40566,132.08419 h 0.46326 v 1.19932 h -0.46326 z m 0.69372,0 h 0.46327 v 1.19932 h -0.46327 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 106.09601,132.08419 h 0.46327 v 3.41923 h -0.46327 z m 0.26808,0 h 1.29338 v 0.43975 h -1.29338 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 108.99273,135.5387 q -0.31041,0 -0.54087,-0.12699 -0.23045,-0.12934 -0.35509,-0.3645 -0.12228,-0.23751 -0.12228,-0.55968 v -1.38744 q 0,-0.32217 0.12228,-0.55968 0.12464,-0.23752 0.35509,-0.3645 0.23046,-0.12699 0.54087,-0.12699 0.31041,0 0.54087,0.12699 0.23046,0.12698 0.35274,0.3645 0.12464,0.23751 0.12464,0.55968 v 1.38744 q 0,0.32217 -0.12464,0.55968 -0.12228,0.23516 -0.35274,0.3645 -0.23046,0.12699 -0.54087,0.12699 z m 0,-0.45386 q 0.16697,0 0.2916,-0.0706 0.12464,-0.0705 0.19048,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41566 q 0,-0.17873 -0.0682,-0.31041 -0.0658,-0.13169 -0.19048,-0.20224 -0.12463,-0.0705 -0.2916,-0.0705 -0.16696,0 -0.2916,0.0705 -0.12463,0.0705 -0.19283,0.20224 -0.0658,0.13168 -0.0658,0.31041 v 1.41566 q 0,0.17872 0.0658,0.31041 0.0682,0.13169 0.19283,0.20224 0.12464,0.0706 0.2916,0.0706 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16394"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 110.82888,133.73737 h 0.86304 q 0.12228,0 0.21164,-0.0564 0.0917,-0.0564 0.1411,-0.16226 0.0494,-0.10582 0.0494,-0.24692 v -0.27278 q 0,-0.1458 -0.0494,-0.25162 -0.0494,-0.10818 -0.1411,-0.16462 -0.0894,-0.0588 -0.21164,-0.0588 h -0.86304 v -0.43975 h 0.84893 q 0.27279,0 0.47267,0.11053 0.20224,0.11052 0.30806,0.31747 0.10818,0.20459 0.10818,0.48207 v 0.2822 q 0,0.27749 -0.10818,0.47972 -0.10817,0.20224 -0.30806,0.31277 -0.19988,0.10817 -0.47267,0.10817 h -0.84893 z m -0.24692,-1.65318 h 0.46327 v 3.41923 h -0.46327 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 114.05483,135.5387 q -0.31041,0 -0.54087,-0.12699 -0.23046,-0.12934 -0.35509,-0.3645 -0.12228,-0.23751 -0.12228,-0.55968 v -1.38744 q 0,-0.32217 0.12228,-0.55968 0.12463,-0.23752 0.35509,-0.3645 0.23046,-0.12699 0.54087,-0.12699 0.31041,0 0.54087,0.12699 0.23045,0.12698 0.35274,0.3645 0.12463,0.23751 0.12463,0.55968 v 1.38744 q 0,0.32217 -0.12463,0.55968 -0.12229,0.23516 -0.35274,0.3645 -0.23046,0.12699 -0.54087,0.12699 z m 0,-0.45386 q 0.16696,0 0.2916,-0.0706 0.12463,-0.0705 0.19048,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41566 q 0,-0.17873 -0.0682,-0.31041 -0.0659,-0.13169 -0.19048,-0.20224 -0.12464,-0.0705 -0.2916,-0.0705 -0.16696,0 -0.2916,0.0705 -0.12463,0.0705 -0.19283,0.20224 -0.0659,0.13168 -0.0659,0.31041 v 1.41566 q 0,0.17872 0.0659,0.31041 0.0682,0.13169 0.19283,0.20224 0.12464,0.0706 0.2916,0.0706 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 115.38774,135.06367 h 0.04 q 0.2234,0 0.34568,-0.20223 0.12228,-0.20224 0.12228,-0.56909 v -2.20816 h 0.46327 v 2.25049 q 0,0.32452 -0.10582,0.55498 -0.10347,0.23045 -0.30101,0.35274 -0.19753,0.11993 -0.47737,0.11993 h -0.087 z m -0.0353,0 h 0.46327 v 1.14759 h -0.46327 z m 0,0 h 2.44332 v 0.43975 h -2.44332 z m 2.23167,0 h 0.46327 v 1.14759 h -0.46327 z m -0.39742,-2.97948 h 0.46327 v 3.41923 h -0.46327 z m -0.99237,0 h 1.20637 v 0.43975 h -1.20637 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 119.47672,135.5387 q -0.301,0 -0.52441,-0.12934 -0.22105,-0.12934 -0.34098,-0.3692 -0.11993,-0.24222 -0.11993,-0.56909 v -1.35217 q 0,-0.32923 0.11993,-0.56909 0.11993,-0.24221 0.34098,-0.37155 0.22341,-0.12934 0.52441,-0.12934 0.2916,0 0.50324,0.11758 0.21165,0.11758 0.33158,0.34569 0.12228,0.2281 0.14345,0.55497 v 0 h -0.47032 v 0 q -0.0165,-0.18107 -0.0823,-0.30806 -0.0658,-0.12698 -0.17637,-0.19283 -0.10817,-0.0658 -0.24927,-0.0658 -0.15756,0 -0.27278,0.0753 -0.11523,0.0752 -0.17873,0.21399 -0.0635,0.13875 -0.0635,0.32923 v 1.35217 q 0,0.18813 0.0635,0.32922 0.0635,0.13875 0.17873,0.214 0.11522,0.0729 0.27278,0.0729 0.1411,0 0.24927,-0.0635 0.11053,-0.0635 0.17637,-0.19048 0.0658,-0.12699 0.0823,-0.31277 v 0 h 0.47032 v 0 q -0.0212,0.32688 -0.14345,0.55498 -0.11993,0.22811 -0.33158,0.34569 -0.21164,0.11758 -0.50324,0.11758 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 121.78319,133.63625 0.73605,-1.55206 h 0.52911 l -0.99943,1.95419 z m -0.0141,0.35274 0.40918,-0.23751 1.01354,1.75194 h -0.56909 z m -0.81365,-1.9048 h 0.46326 v 3.41923 h -0.46326 z m 0.23281,1.50268 h 0.99237 v 0.4374 h -0.99237 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 124.30131,132.08419 h 0.40918 l 1.01589,3.41923 h -0.49854 l -0.72194,-2.73726 -0.7243,2.73726 h -0.49618 z m -0.47502,2.23403 h 1.38979 v 0.43739 h -1.38979 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 126.95111,134.12774 q -0.28219,0 -0.49148,-0.10818 -0.20929,-0.11052 -0.32452,-0.31511 -0.11288,-0.20694 -0.11288,-0.48443 v -0.24457 q 0,-0.27278 0.11288,-0.47502 0.11287,-0.20224 0.32217,-0.31041 0.20929,-0.10818 0.49383,-0.10818 h 0.83482 v 0.43975 h -0.86539 q -0.12934,0 -0.2234,0.0588 -0.0941,0.0564 -0.1458,0.16697 -0.0517,0.10817 -0.0517,0.25397 v 0.2187 q 0,0.14345 0.0517,0.24927 0.0517,0.10582 0.1458,0.16226 0.0964,0.0564 0.2234,0.0564 h 0.86539 v 0.43975 z m -0.21634,-0.214 0.43739,0.10817 -0.63493,1.48151 h -0.52676 z m 0.79719,-1.8319 h 0.46326 v 3.42158 h -0.46326 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 131.29127,132.08419 h 0.46326 v 3.41923 h -0.46326 z m -1.51914,0 h 0.46327 v 3.41923 h -0.46327 z m 0.29866,0 h 1.45799 v 0.43975 h -1.45799 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16410"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 133.39315,135.5387 q -0.31041,0 -0.54087,-0.12699 -0.23046,-0.12934 -0.35509,-0.3645 -0.12229,-0.23751 -0.12229,-0.55968 v -1.38744 q 0,-0.32217 0.12229,-0.55968 0.12463,-0.23752 0.35509,-0.3645 0.23046,-0.12699 0.54087,-0.12699 0.31041,0 0.54087,0.12699 0.23045,0.12698 0.35274,0.3645 0.12463,0.23751 0.12463,0.55968 v 1.38744 q 0,0.32217 -0.12463,0.55968 -0.12229,0.23516 -0.35274,0.3645 -0.23046,0.12699 -0.54087,0.12699 z m 0,-0.45386 q 0.16696,0 0.2916,-0.0706 0.12463,-0.0705 0.19048,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41566 q 0,-0.17873 -0.0682,-0.31041 -0.0658,-0.13169 -0.19048,-0.20224 -0.12464,-0.0705 -0.2916,-0.0705 -0.16697,0 -0.2916,0.0705 -0.12464,0.0705 -0.19283,0.20224 -0.0658,0.13168 -0.0658,0.31041 v 1.41566 q 0,0.17872 0.0658,0.31041 0.0682,0.13169 0.19283,0.20224 0.12463,0.0706 0.2916,0.0706 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 134.88126,135.06603 h 0.002 q 0.1411,0 0.23281,-0.0659 0.0917,-0.0682 0.13639,-0.20459 0.0447,-0.13874 0.0447,-0.35039 v -2.36101 h 0.46326 v 2.36336 q 0,0.35745 -0.0917,0.59261 -0.0917,0.23281 -0.27514,0.34803 -0.18342,0.11523 -0.46326,0.11523 h -0.0494 z m 1.72608,-2.98184 h 0.46326 v 3.41923 h -0.46326 z m -1.01119,0 h 1.24635 v 0.43975 h -1.24635 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 139.35591,135.50107 v -2.58911 l 0.0564,0.0611 -1.30749,2.52797 h -0.38331 v -3.41688 h 0.45386 v 2.61734 l -0.0564,-0.0611 1.31219,-2.5562 h 0.37626 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 141.28847,133.63625 0.73606,-1.55206 h 0.52911 l -0.99943,1.95419 z m -0.0141,0.35274 0.40918,-0.23751 1.01354,1.75194 H 142.128 Z m -0.81365,-1.9048 h 0.46327 v 3.41923 h -0.46327 z m 0.23281,1.50268 h 0.99237 v 0.4374 h -0.99237 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 142.97883,135.06603 h 0.002 q 0.1411,0 0.23281,-0.0659 0.0917,-0.0682 0.13639,-0.20459 0.0447,-0.13874 0.0447,-0.35039 v -2.36101 h 0.46327 v 2.36336 q 0,0.35745 -0.0917,0.59261 -0.0917,0.23281 -0.27513,0.34803 -0.18343,0.11523 -0.46327,0.11523 h -0.0494 z m 1.72607,-2.98184 h 0.46327 v 3.41923 h -0.46327 z m -1.01118,0 h 1.24634 v 0.43975 h -1.24634 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16420"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 147.45348,135.50107 v -2.58911 l 0.0564,0.0611 -1.30749,2.52797 h -0.38331 v -3.41688 h 0.45386 v 2.61734 l -0.0564,-0.0611 1.3122,-2.5562 h 0.37625 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 150.07741,132.08419 h 0.46327 v 3.41923 h -0.46327 z m -1.51913,0 h 0.46561 v 3.41923 h -0.46561 z m 0.29865,1.51679 h 1.45799 v 0.4374 h -1.45799 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 152.82833,135.50107 v -2.58911 l 0.0564,0.0611 -1.30749,2.52797 h -0.38331 v -3.41688 h 0.45386 v 2.61734 l -0.0564,-0.0611 1.3122,-2.5562 h 0.37625 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 154.7609,133.63625 0.73605,-1.55206 h 0.52911 l -0.99943,1.95419 z m -0.0141,0.35274 0.40918,-0.23751 1.01354,1.75194 h -0.56909 z m -0.81365,-1.9048 h 0.46326 v 3.41923 h -0.46326 z m 0.23281,1.50268 h 0.99237 v 0.4374 h -0.99237 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 157.27902,132.08419 h 0.40917 l 1.0159,3.41923 h -0.49854 l -0.72195,-2.73726 -0.72429,2.73726 h -0.49619 z m -0.47503,2.23403 h 1.3898 v 0.43739 h -1.3898 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 162.69855,133.83143 h 1.12642 v 0.45386 h -1.12642 z m -2.45977,-1.74724 h 0.41388 l 1.28868,2.63145 -0.0658,0.0611 v -2.69259 h 0.44916 v 3.41688 h -0.41623 l -1.28398,-2.5703 0.0635,-0.0611 v 2.63144 h -0.44915 z m 3.02416,1.48151 q -0.27044,0 -0.41859,-0.14815 -0.1458,-0.14815 -0.1458,-0.41388 v -0.38801 q 0,-0.26103 0.1458,-0.40448 0.14815,-0.14345 0.41859,-0.14345 0.27043,0 0.41623,0.1458 0.1458,0.14345 0.1458,0.40448 v 0.38566 q 0,0.26573 -0.1458,0.41388 -0.1458,0.14815 -0.41623,0.14815 z m -0.002,-0.35979 q 0.0894,0 0.13639,-0.0564 0.047,-0.0564 0.047,-0.15756 v -0.37155 q 0,-0.0917 -0.047,-0.1411 -0.047,-0.0517 -0.13639,-0.0517 -0.087,0 -0.13404,0.0517 -0.0447,0.0517 -0.0447,0.1458 v 0.36685 q 0,0.10347 0.0447,0.15991 0.047,0.0541 0.13404,0.0541 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 165.09909,135.5387 q -0.41859,0 -0.64199,-0.22811 -0.2234,-0.23046 -0.2234,-0.64434 v -1.74724 q 0,-0.41623 0.2234,-0.64434 0.2234,-0.2281 0.64199,-0.2281 0.42094,0 0.64199,0.2281 0.2234,0.22811 0.2234,0.64434 v 1.74724 q 0,0.41388 -0.2234,0.64434 -0.22341,0.22811 -0.64199,0.22811 z m 0,-0.43975 q 0.19989,0 0.301,-0.11288 0.10347,-0.11288 0.10347,-0.31982 v -1.74724 q 0,-0.20929 -0.10111,-0.32217 -0.10112,-0.11287 -0.30336,-0.11287 -0.19989,0 -0.30101,0.11287 -0.10111,0.11288 -0.10111,0.32217 v 1.74724 q 0,0.20694 0.10111,0.31982 0.10112,0.11288 0.30101,0.11288 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 167.3209,135.5387 q -0.41858,0 -0.64198,-0.22811 -0.22341,-0.23046 -0.22341,-0.64434 v -1.74724 q 0,-0.41623 0.22341,-0.64434 0.2234,-0.2281 0.64198,-0.2281 0.42094,0 0.64199,0.2281 0.2234,0.22811 0.2234,0.64434 v 1.74724 q 0,0.41388 -0.2234,0.64434 -0.2234,0.22811 -0.64199,0.22811 z m 0,-0.43975 q 0.19989,0 0.30101,-0.11288 0.10347,-0.11288 0.10347,-0.31982 v -1.74724 q 0,-0.20929 -0.10112,-0.32217 -0.10112,-0.11287 -0.30336,-0.11287 -0.19988,0 -0.301,0.11287 -0.10112,0.11288 -0.10112,0.32217 v 1.74724 q 0,0.20694 0.10112,0.31982 0.10112,0.11288 0.301,0.11288 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 168.68438,132.08419 h 0.46327 v 1.19932 h -0.46327 z m 0.69373,0 h 0.46326 v 1.19932 h -0.46326 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path16438"
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\u0418\\u043D\\u0434\\u0435\\u043A\\u0441, \\u0433. \\u0413\\u043E\\u0440\\u043E\\u0434, \\u0443\\u043B. \\u0423\\u043B\\u0438\\u0446\\u0430, \\u0434.1, \\u0441\\u0442. 1, \\u0422\\u0435\\u043B.: 8-012-345-67-89; 8-012-345-67-89 \\u2116__________________\\u043E\\u0442______________________ \\u043D\\u0430 \\u2116_______________\\u043E\\u0442______________________",
    id: "text618433-5",
    style: {
      fontSize: "4.4177px",
      lineHeight: 0,
      display: "inline",
      fill: "#074e9c",
      strokeWidth: 0.184071
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 109.65443,141.04786 v -2.37494 l 0.0518,0.0561 -1.19934,2.31886 h -0.35161 v -3.13424 h 0.41632 v 2.40083 l -0.0518,-0.0561 1.20365,-2.34475 h 0.34513 v 3.13424 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 111.79425,138.81097 h 0.42279 v 2.23905 h -0.42279 z m -1.13678,0 h 0.42494 v 2.23905 h -0.42494 z m 0.25885,0.94264 h 1.12168 v 0.39259 h -1.12168 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 112.69159,140.65743 h 0.0518 q 0.10139,0 0.16178,-0.0626 0.0626,-0.0647 0.0884,-0.18982 0.0259,-0.12511 0.0259,-0.32787 v -1.26621 h 0.42494 v 1.36975 q 0,0.35591 -0.15746,0.53711 -0.15747,0.18119 -0.44867,0.18119 h -0.0733 z m -0.069,0 h 0.42279 v 0.95559 h -0.42279 z m 0,0 h 1.90254 v 0.39259 h -1.90254 z m 1.72782,0 h 0.42494 v 0.95559 h -0.42494 z m -0.36455,-1.84646 h 0.42495 v 2.23905 h -0.42495 z m -0.69242,0 h 0.86715 v 0.39259 h -0.86715 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 115.8776,141.08237 q -0.26101,0 -0.44651,-0.10138 -0.18551,-0.10138 -0.28258,-0.29552 -0.0971,-0.19414 -0.0971,-0.47024 v -0.52849 q 0,-0.28689 0.0949,-0.49181 0.0949,-0.20492 0.27179,-0.31062 0.17904,-0.10785 0.43358,-0.10785 0.24375,0 0.41631,0.11216 0.17473,0.11002 0.26532,0.32141 0.0928,0.21139 0.0928,0.51123 v 0.37749 h -1.27268 v -0.34729 h 0.86499 v -0.12511 q 0,-0.22003 -0.0992,-0.34298 -0.0992,-0.12511 -0.26747,-0.12511 -0.18767,0 -0.29121,0.13158 -0.10354,0.13158 -0.10354,0.37318 v 0.56299 q 0,0.21571 0.11001,0.33651 0.11001,0.11864 0.31062,0.11864 0.13158,0 0.21571,-0.0604 0.0863,-0.0604 0.11864,-0.17472 v 0 l 0.38827,0.11648 v 0 q -0.0582,0.25885 -0.24159,0.39043 -0.18119,0.12942 -0.48103,0.12942 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 117.78877,139.77087 0.47456,-0.9599 h 0.4724 l -0.69889,1.30072 z m -0.64712,-0.9599 h 0.42495 v 2.23905 h -0.42495 z m 0.65575,1.30072 0.31925,-0.25885 0.72262,1.19718 h -0.50907 z m -0.4422,-0.37749 h 0.78086 v 0.40122 h -0.78086 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 119.81643,141.08237 q -0.25885,0 -0.4422,-0.0949 -0.18335,-0.0949 -0.28042,-0.2761 -0.0949,-0.18336 -0.0949,-0.4422 v -0.6687 q 0,-0.26101 0.0949,-0.44651 0.0971,-0.18551 0.28042,-0.28043 0.18335,-0.0971 0.4422,-0.0971 0.21571,0 0.37102,0.0669 0.15746,0.0647 0.25022,0.19845 0.0949,0.13158 0.12295,0.32787 v 0 l -0.39259,0.11433 v 0 q -0.0302,-0.15315 -0.11864,-0.23081 -0.0863,-0.0777 -0.22649,-0.0777 -0.18982,0 -0.29552,0.11216 -0.10354,0.11002 -0.10354,0.31278 v 0.6687 q 0,0.19845 0.10354,0.3063 0.1057,0.10785 0.29552,0.10785 0.14021,0 0.22865,-0.0755 0.0884,-0.0777 0.11864,-0.2265 v 0 l 0.39259,0.12296 v 0 q -0.028,0.19198 -0.12295,0.3214 -0.0928,0.12943 -0.25023,0.19414 -0.15531,0.0625 -0.37317,0.0625 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 120.81084,140.6035 h 0.44652 v 0.67733 l -0.44652,0.48102 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 122.78889,138.81097 h 0.42494 v 2.23905 h -0.42494 z m 0.23296,0 h 0.99873 v 0.40337 h -0.99873 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 124.32257,140.6035 h 0.44651 v 0.44652 h -0.44651 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 126.30924,137.91362 h 0.42494 v 3.1364 h -0.42494 z m 0.24591,0 h 1.18639 v 0.40338 h -1.18639 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 128.54182,141.08237 q -0.24591,0 -0.42063,-0.0949 -0.17473,-0.0949 -0.26748,-0.27395 -0.0928,-0.18119 -0.0928,-0.43573 v -0.70752 q 0,-0.25238 0.0928,-0.42926 0.0927,-0.17904 0.26748,-0.27179 0.17472,-0.0949 0.42063,-0.0949 0.24375,0 0.41847,0.0949 0.17472,0.0927 0.26532,0.27179 0.0906,0.17688 0.0906,0.42926 v 0.71399 q 0,0.25238 -0.0906,0.43142 -0.0906,0.17904 -0.26532,0.27395 -0.17472,0.0927 -0.41847,0.0927 z m -0.002,-0.40768 q 0.1661,0 0.25885,-0.10354 0.0927,-0.1057 0.0927,-0.29768 v -0.69458 q 0,-0.18767 -0.0927,-0.29121 -0.0927,-0.10354 -0.25885,-0.10354 -0.16825,0 -0.26101,0.10354 -0.0927,0.10354 -0.0927,0.29121 v 0.69458 q 0,0.18982 0.0927,0.29552 0.0928,0.1057 0.26101,0.1057 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 129.84038,138.81097 h 0.42495 v 3.14934 h -0.42495 z m 0.91029,2.2714 q -0.18335,0 -0.31925,-0.10138 -0.1359,-0.10138 -0.19629,-0.28258 l 0.0302,-0.40553 q 0,0.12727 0.041,0.21787 0.041,0.0906 0.11864,0.13805 0.0777,0.0475 0.18767,0.0475 0.16825,0 0.261,-0.11217 0.0949,-0.11433 0.0949,-0.31925 v -0.67085 q 0,-0.20492 -0.0949,-0.31925 -0.0927,-0.11432 -0.261,-0.11432 -0.11002,0 -0.18767,0.0475 -0.0777,0.0453 -0.11864,0.13374 -0.041,0.0884 -0.041,0.21139 l -0.0453,-0.36886 q 0.0841,-0.19629 0.22865,-0.30199 0.14452,-0.10785 0.3214,-0.10785 0.19845,0 0.33866,0.0949 0.14021,0.0949 0.2114,0.27611 0.0733,0.18119 0.0733,0.43788 v 0.68811 q 0,0.25669 -0.0755,0.43789 -0.0755,0.18119 -0.22002,0.27826 -0.14453,0.0949 -0.34729,0.0949 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 132.64458,141.08237 q -0.2459,0 -0.42063,-0.0949 -0.17472,-0.0949 -0.26748,-0.27395 -0.0927,-0.18119 -0.0927,-0.43573 v -0.70752 q 0,-0.25238 0.0927,-0.42926 0.0928,-0.17904 0.26748,-0.27179 0.17473,-0.0949 0.42063,-0.0949 0.24375,0 0.41848,0.0949 0.17472,0.0927 0.26532,0.27179 0.0906,0.17688 0.0906,0.42926 v 0.71399 q 0,0.25238 -0.0906,0.43142 -0.0906,0.17904 -0.26532,0.27395 -0.17473,0.0927 -0.41848,0.0927 z m -0.002,-0.40768 q 0.16609,0 0.25885,-0.10354 0.0927,-0.1057 0.0927,-0.29768 v -0.69458 q 0,-0.18767 -0.0927,-0.29121 -0.0928,-0.10354 -0.25885,-0.10354 -0.16826,0 -0.26101,0.10354 -0.0927,0.10354 -0.0927,0.29121 v 0.69458 q 0,0.18982 0.0927,0.29552 0.0927,0.1057 0.26101,0.1057 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 133.73175,140.65743 h 0.0518 q 0.10138,0 0.16178,-0.0626 0.0626,-0.0647 0.0884,-0.18982 0.0259,-0.12511 0.0259,-0.32787 v -1.26621 h 0.42494 v 1.36975 q 0,0.35591 -0.15746,0.53711 -0.15747,0.18119 -0.44868,0.18119 h -0.0733 z m -0.069,0 h 0.42278 v 0.95559 h -0.42278 z m 0,0 h 1.90254 v 0.39259 h -1.90254 z m 1.72782,0 h 0.42494 v 0.95559 h -0.42494 z m -0.36455,-1.84646 h 0.42494 v 2.23905 H 135.026 Z m -0.69242,0 h 0.86714 v 0.39259 h -0.86714 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 136.13258,140.6035 h 0.44652 v 0.67733 l -0.44652,0.48102 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 139.66588,138.81097 -0.8089,2.76322 q -0.0431,0.14452 -0.12512,0.23512 -0.082,0.0906 -0.20923,0.13158 -0.12727,0.0431 -0.30846,0.0431 h -0.0755 v -0.40553 h 0.0755 q 0.13589,0 0.21355,-0.0561 0.0798,-0.0561 0.12079,-0.18335 l 0.68595,-2.5281 z m -1.74723,0 h 0.42925 l 0.58242,1.93921 -0.2265,0.47888 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 139.84707,140.67253 q 0.13374,0 0.20277,-0.1057 0.0712,-0.10569 0.0712,-0.30415 v -1.45171 h 0.42495 v 1.50133 q 0,0.2459 -0.0755,0.41416 -0.0733,0.16825 -0.22002,0.25669 -0.14668,0.0863 -0.36024,0.0863 h -0.0431 z m 1.2468,-1.86156 h 0.42494 v 2.23905 h -0.42494 z m -0.6989,0 h 0.91676 v 0.40337 h -0.91676 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16491"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 142.01925,140.6035 h 0.44652 v 0.44652 h -0.44652 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 143.82689,137.91362 h 0.46593 l 0.67516,2.30161 -0.27395,0.3516 z m 1.31582,2.5432 q -0.0626,0.20924 -0.15963,0.34729 -0.0949,0.13805 -0.23296,0.20924 -0.13806,0.069 -0.32572,0.069 h -0.27395 v -0.42063 h 0.27395 q 0.0927,0 0.16394,-0.0431 0.0712,-0.0431 0.12295,-0.12511 0.0539,-0.082 0.0884,-0.20708 l 0.64712,-2.37279 h 0.44436 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 146.04436,140.67253 q 0.13374,0 0.20277,-0.1057 0.0712,-0.10569 0.0712,-0.30415 v -1.45171 h 0.42495 v 1.50133 q 0,0.2459 -0.0755,0.41416 -0.0733,0.16825 -0.22002,0.25669 -0.14668,0.0863 -0.36023,0.0863 h -0.0431 z m 1.2468,-1.86156 h 0.42494 v 2.23905 h -0.42494 z m -0.6989,0 h 0.91676 v 0.40337 h -0.91676 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 149.44176,141.04786 v -1.5531 l 0.0518,0.0561 -0.84557,1.49701 h -0.35376 v -2.23689 h 0.40769 v 1.57035 l -0.0518,-0.0561 0.84989,-1.51427 h 0.34944 v 2.23689 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 151.53198,138.81097 h 0.42494 v 2.23905 h -0.42494 z m -0.84558,1.84646 h 1.07854 v 0.39259 h -1.07854 z m -0.25885,-1.84646 h 0.42495 v 2.23905 h -0.42495 z m 1.47329,1.84646 h 0.42279 v 0.95559 h -0.42279 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16501"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 153.8077,139.51633 q 0,-0.17472 -0.0949,-0.27179 -0.0927,-0.0971 -0.26316,-0.0971 -0.12511,0 -0.22002,0.0582 -0.0949,0.0582 -0.14237,0.16394 l -0.36023,-0.10569 q 0.0604,-0.23297 0.24806,-0.36024 0.18983,-0.12942 0.4724,-0.12942 0.24375,0 0.41632,0.0884 0.17257,0.0863 0.26101,0.25022 0.0906,0.16394 0.0906,0.39475 v 1.54231 h -0.40768 z m -0.47456,1.56604 q -0.34298,0 -0.51339,-0.16393 -0.17041,-0.16394 -0.17041,-0.49397 0,-0.35592 0.17904,-0.5328 0.1812,-0.17688 0.54358,-0.17688 h 0.45515 l 0.0302,0.36023 h -0.48319 q -0.16178,0 -0.24159,0.0863 -0.0798,0.0863 -0.0798,0.26317 0,0.14883 0.0884,0.22217 0.0884,0.0734 0.26748,0.0734 0.2006,0 0.29983,-0.069 0.0992,-0.0712 0.0992,-0.21571 l 0.0453,0.25885 q -0.0302,0.13158 -0.0971,0.21787 -0.0669,0.0863 -0.17257,0.12942 -0.1057,0.041 -0.25022,0.041 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16503"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 154.70504,140.6035 h 0.44652 v 0.67733 l -0.44652,0.48102 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 156.57954,140.65743 h 0.0518 q 0.10139,0 0.16178,-0.0626 0.0626,-0.0647 0.0884,-0.18982 0.0259,-0.12511 0.0259,-0.32787 v -1.26621 h 0.42494 v 1.36975 q 0,0.35591 -0.15746,0.53711 -0.15747,0.18119 -0.44867,0.18119 h -0.0733 z m -0.069,0 h 0.42278 v 0.95559 h -0.42278 z m 0,0 h 1.90254 v 0.39259 h -1.90254 z m 1.72782,0 h 0.42494 v 0.95559 h -0.42494 z m -0.36455,-1.84646 h 0.42495 v 2.23905 h -0.42495 z m -0.69242,0 h 0.86715 v 0.39259 h -0.86715 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16507"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 158.98038,140.6035 h 0.44651 v 0.44652 h -0.44651 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 160.6629,141.05002 h -0.42495 v -2.68557 l -0.46161,0.28474 v -0.44005 l 0.4422,-0.29552 h 0.44436 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 161.17197,140.6035 h 0.44651 v 0.67733 l -0.44651,0.48102 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16513"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 163.91362,141.08237 q -0.25885,0 -0.4422,-0.0949 -0.18336,-0.0949 -0.28043,-0.2761 -0.0949,-0.18336 -0.0949,-0.4422 v -0.6687 q 0,-0.26101 0.0949,-0.44651 0.0971,-0.18551 0.28043,-0.28043 0.18335,-0.0971 0.4422,-0.0971 0.2157,0 0.37101,0.0669 0.15747,0.0647 0.25023,0.19845 0.0949,0.13158 0.12295,0.32787 v 0 l -0.39259,0.11433 v 0 q -0.0302,-0.15315 -0.11864,-0.23081 -0.0863,-0.0777 -0.22649,-0.0777 -0.18983,0 -0.29552,0.11216 -0.10354,0.11002 -0.10354,0.31278 v 0.6687 q 0,0.19845 0.10354,0.3063 0.10569,0.10785 0.29552,0.10785 0.14021,0 0.22865,-0.0755 0.0884,-0.0777 0.11864,-0.2265 v 0 l 0.39259,0.12296 v 0 q -0.028,0.19198 -0.12296,0.3214 -0.0927,0.12943 -0.25022,0.19414 -0.15531,0.0625 -0.37317,0.0625 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 165.30062,138.92314 h 0.42494 v 2.12688 h -0.42494 z m -0.51986,-0.11217 h 1.46466 v 0.39259 h -1.46466 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 166.62722,140.6035 h 0.44652 v 0.44652 h -0.44652 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16519"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 169.34083,141.05002 h -0.42495 v -2.68557 l -0.46161,0.28474 v -0.44005 l 0.4422,-0.29552 h 0.44436 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 169.8499,140.6035 h 0.44652 v 0.67733 l -0.44652,0.48102 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 105.43733,142.8089 h 0.42495 v 2.8797 h -0.42495 z m -0.71615,-0.25669 h 1.85509 v 0.40337 h -1.85509 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 107.37871,145.72096 q -0.26101,0 -0.44652,-0.10138 -0.18551,-0.10139 -0.28258,-0.29552 -0.0971,-0.19414 -0.0971,-0.47025 v -0.52848 q 0,-0.28689 0.0949,-0.49182 0.0949,-0.20492 0.27179,-0.31062 0.17904,-0.10785 0.43357,-0.10785 0.24375,0 0.41632,0.11217 0.17472,0.11001 0.26532,0.3214 0.0928,0.2114 0.0928,0.51123 v 0.37749 h -1.27267 v -0.34729 h 0.86498 v -0.12511 q 0,-0.22002 -0.0992,-0.34298 -0.0992,-0.12511 -0.26748,-0.12511 -0.18766,0 -0.2912,0.13159 -0.10354,0.13158 -0.10354,0.37317 v 0.563 q 0,0.21571 0.11001,0.3365 0.11001,0.11864 0.31062,0.11864 0.13158,0 0.2157,-0.0604 0.0863,-0.0604 0.11864,-0.17472 v 0 l 0.38828,0.11648 v 0 q -0.0582,0.25885 -0.24159,0.39043 -0.1812,0.12943 -0.48103,0.12943 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 108.38391,145.31111 q 0.13373,0 0.20276,-0.10569 0.0712,-0.1057 0.0712,-0.30415 v -1.45172 h 0.42495 v 1.50133 q 0,0.24591 -0.0755,0.41416 -0.0733,0.16825 -0.22002,0.25669 -0.14668,0.0863 -0.36023,0.0863 h -0.0431 z m 1.24679,-1.86156 h 0.42494 v 2.23905 h -0.42494 z m -0.6989,0 h 0.91676 v 0.40338 h -0.91676 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 110.55609,145.24209 h 0.44651 v 0.44651 h -0.44651 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 111.42539,145.24209 h 0.44651 v 0.44651 h -0.44651 z m 0,-1.79901 h 0.44651 v 0.44652 h -0.44651 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 114.18214,145.72096 q -0.25238,0 -0.43789,-0.0928 -0.18335,-0.0927 -0.28473,-0.26747 -0.0992,-0.17473 -0.0992,-0.40985 v -0.28689 q 0,-0.20277 0.10138,-0.37102 0.10138,-0.17041 0.27827,-0.261 -0.151,-0.0777 -0.23944,-0.21787 -0.0863,-0.14237 -0.0863,-0.30415 v -0.25669 q 0,-0.22434 0.0927,-0.38827 0.0928,-0.1661 0.26532,-0.25454 0.17473,-0.0906 0.40985,-0.0906 0.23728,0 0.40984,0.0906 0.17257,0.0884 0.26532,0.25454 0.0949,0.16393 0.0949,0.38827 v 0.25669 q 0,0.1661 -0.0906,0.30631 -0.0884,0.14021 -0.2416,0.21571 0.17904,0.0906 0.28258,0.261 0.10354,0.16825 0.10354,0.37102 v 0.28689 q 0,0.23512 -0.10138,0.40985 -0.0992,0.17472 -0.28474,0.26747 -0.1855,0.0928 -0.43788,0.0928 z m 0,-0.40985 q 0.12295,0 0.21139,-0.0475 0.0906,-0.0475 0.13805,-0.13374 0.0496,-0.0884 0.0496,-0.20492 v -0.29121 q 0,-0.11217 -0.0496,-0.19414 -0.0475,-0.0841 -0.13805,-0.12726 -0.0884,-0.0453 -0.21139,-0.0453 -0.1208,0 -0.2114,0.0453 -0.0906,0.0453 -0.14021,0.12942 -0.0474,0.082 -0.0474,0.19414 v 0.29336 q 0,0.11648 0.0474,0.20277 0.0496,0.0863 0.14021,0.13374 0.0906,0.0453 0.2114,0.0453 z m 0,-1.44955 q 0.10569,0 0.18335,-0.0431 0.0777,-0.0453 0.11864,-0.12942 0.0431,-0.0841 0.0431,-0.19845 v -0.18982 q 0,-0.11217 -0.0431,-0.1963 -0.041,-0.0841 -0.11864,-0.12942 -0.0777,-0.0453 -0.18335,-0.0453 -0.10354,0 -0.1812,0.0453 -0.0777,0.0453 -0.12079,0.12942 -0.041,0.0841 -0.041,0.19845 v 0.19198 q 0,0.11217 0.041,0.1963 0.0431,0.082 0.12079,0.12726 0.0777,0.0431 0.1812,0.0431 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 116.81162,144.36416 v 0.40121 h -1.27052 v -0.40121 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 118.15116,145.72096 q -0.38396,0 -0.58888,-0.20924 -0.20492,-0.21139 -0.20492,-0.59104 v -1.60271 q 0,-0.3818 0.20492,-0.59104 0.20492,-0.20923 0.58888,-0.20923 0.38612,0 0.58889,0.20923 0.20492,0.20924 0.20492,0.59104 v 1.60271 q 0,0.37965 -0.20492,0.59104 -0.20493,0.20924 -0.58889,0.20924 z m 0,-0.40337 q 0.18336,0 0.27611,-0.10354 0.0949,-0.10354 0.0949,-0.29337 v -1.60271 q 0,-0.19198 -0.0928,-0.29552 -0.0928,-0.10354 -0.27827,-0.10354 -0.18335,0 -0.2761,0.10354 -0.0928,0.10354 -0.0928,0.29552 v 1.60271 q 0,0.18983 0.0928,0.29337 0.0927,0.10354 0.2761,0.10354 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 120.23706,145.6886 h -0.42495 v -2.68556 l -0.46161,0.28473 v -0.44004 l 0.4422,-0.29552 h 0.44436 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 120.76554,145.3219 0.89088,-1.34818 q 0.11864,-0.18982 0.18119,-0.36023 0.0626,-0.17256 0.0626,-0.30846 v -0.006 q 0,-0.17904 -0.0884,-0.27395 -0.0863,-0.0971 -0.25238,-0.0971 -0.17472,0 -0.27395,0.1208 -0.0971,0.11864 -0.11001,0.34297 v 0.006 h -0.43789 v -0.006 q 0.0194,-0.28042 0.11864,-0.47455 0.0992,-0.1963 0.27179,-0.29552 0.17473,-0.10139 0.41632,-0.10139 0.25669,0 0.43357,0.0906 0.17688,0.0906 0.26748,0.26532 0.0928,0.17472 0.0928,0.4271 v 0.004 q 0,0.17688 -0.0733,0.38827 -0.0712,0.20924 -0.20708,0.43142 l -0.7442,1.15835 h 1.03109 v 0.40337 h -1.57899 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 124.10902,144.36416 v 0.40121 h -1.27052 v -0.40121 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 125.37522,145.72096 q -0.26747,0 -0.44867,-0.0928 -0.17904,-0.0927 -0.27395,-0.28257 -0.0928,-0.19198 -0.10569,-0.48319 v 0 h 0.42925 v 0 q 0.006,0.15747 0.0539,0.25669 0.0475,0.0971 0.13158,0.14453 0.0863,0.0475 0.21355,0.0475 0.17904,0 0.27611,-0.0971 0.0992,-0.0992 0.0992,-0.27395 v -0.2718 q 0,-0.19413 -0.0906,-0.30199 -0.0906,-0.10785 -0.25238,-0.10785 h -0.22002 v -0.40122 h 0.22002 q 0.13805,0 0.21355,-0.0884 0.0777,-0.0906 0.0777,-0.25022 v -0.27179 q 0,-0.151 -0.0841,-0.23297 -0.0841,-0.0841 -0.24159,-0.0841 -0.10786,0 -0.1812,0.0474 -0.0712,0.0475 -0.11432,0.14668 -0.041,0.0992 -0.0518,0.25454 v 0 h -0.4271 v 0 q 0.0151,-0.29121 0.10569,-0.48103 0.0928,-0.19198 0.26101,-0.28473 0.16825,-0.0928 0.42063,-0.0928 0.3516,0 0.54358,0.19198 0.19414,0.18983 0.19414,0.53496 v 0.25453 q 0,0.17041 -0.0992,0.31494 -0.0971,0.14452 -0.27611,0.23512 0.20276,0.0604 0.31493,0.22649 0.11217,0.1661 0.11217,0.412 v 0.2567 q 0,0.24375 -0.0949,0.41847 -0.0927,0.17472 -0.27395,0.26532 -0.17904,0.0906 -0.43142,0.0906 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 126.64574,144.83656 0.86068,-2.28219 h 0.43789 l -0.83479,2.2563 h 1.35033 v 0.3969 h -1.81411 z m 1.16267,-0.98795 h 0.41847 v 1.84215 h -0.41847 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16549"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 129.66134,145.72096 q -0.23943,0 -0.40769,-0.0906 -0.16825,-0.0906 -0.261,-0.26963 -0.0928,-0.17904 -0.1057,-0.4422 v 0 h 0.42495 v 0 q 0.009,0.19629 0.0971,0.29767 0.0884,0.0992 0.25238,0.0992 0.17041,0 0.26317,-0.10786 0.0949,-0.10785 0.0949,-0.30199 v -0.55221 q 0,-0.19414 -0.0906,-0.30199 -0.0906,-0.10785 -0.25669,-0.10785 -0.11864,0 -0.20492,0.069 -0.0863,0.069 -0.12512,0.19414 h -0.38611 v -1.65448 h 1.43014 v 0.40337 h -1.0052 v 0.7291 q 0.0712,-0.069 0.1661,-0.10786 0.0949,-0.0388 0.19413,-0.0388 0.22218,0 0.37965,0.0971 0.15747,0.0949 0.23944,0.27827 0.082,0.18119 0.082,0.44004 v 0.55221 q 0,0.2567 -0.0928,0.44005 -0.0906,0.18335 -0.26532,0.28042 -0.17472,0.0949 -0.42279,0.0949 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 132.26925,144.36416 v 0.40121 h -1.27052 v -0.40121 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 133.5333,145.72096 q -0.24806,0 -0.42494,-0.0992 -0.17473,-0.10138 -0.26748,-0.2912 -0.0906,-0.18983 -0.0906,-0.45946 v -0.21139 q 0,-0.1812 0.041,-0.34514 0.041,-0.16609 0.12296,-0.36023 0.0129,-0.028 0.0259,-0.0561 0.0129,-0.0302 0.0259,-0.0582 l 0.59104,-1.28778 h 0.45946 l -0.73125,1.56388 -0.0539,-0.0777 q 0.0669,-0.10139 0.17041,-0.15747 0.10354,-0.0561 0.22649,-0.0561 0.21787,0 0.37318,0.0949 0.15746,0.0927 0.23728,0.27395 0.082,0.17903 0.082,0.43357 v 0.23512 q 0,0.26964 -0.0927,0.46377 -0.0927,0.19198 -0.26964,0.29337 -0.17688,0.10138 -0.42494,0.10138 z m 0,-0.40985 q 0.17472,0 0.26748,-0.11001 0.0949,-0.11001 0.0949,-0.30846 v -0.22434 q 0,-0.20708 -0.0971,-0.3214 -0.0971,-0.11433 -0.27395,-0.11433 -0.16609,0 -0.25885,0.11649 -0.0906,0.11432 -0.0906,0.3214 v 0.22434 q 0,0.19845 0.0928,0.30846 0.0949,0.10785 0.26532,0.10785 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 136.24259,142.93185 -0.75066,2.75675 h -0.44652 l 0.75498,-2.73302 h -0.67085 v 0.412 h -0.42495 v -0.81537 h 1.538 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16557"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 138.0265,144.36416 v 0.40121 h -1.27052 v -0.40121 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 139.37252,145.72096 q -0.25238,0 -0.43789,-0.0928 -0.18335,-0.0927 -0.28473,-0.26747 -0.0992,-0.17473 -0.0992,-0.40985 v -0.28689 q 0,-0.20277 0.10138,-0.37102 0.10138,-0.17041 0.27827,-0.261 -0.151,-0.0777 -0.23944,-0.21787 -0.0863,-0.14237 -0.0863,-0.30415 v -0.25669 q 0,-0.22434 0.0927,-0.38827 0.0928,-0.1661 0.26532,-0.25454 0.17473,-0.0906 0.40985,-0.0906 0.23728,0 0.40984,0.0906 0.17257,0.0884 0.26532,0.25454 0.0949,0.16393 0.0949,0.38827 v 0.25669 q 0,0.1661 -0.0906,0.30631 -0.0884,0.14021 -0.2416,0.21571 0.17904,0.0906 0.28258,0.261 0.10354,0.16825 0.10354,0.37102 v 0.28689 q 0,0.23512 -0.10138,0.40985 -0.0992,0.17472 -0.28474,0.26747 -0.1855,0.0928 -0.43788,0.0928 z m 0,-0.40985 q 0.12295,0 0.21139,-0.0475 0.0906,-0.0475 0.13805,-0.13374 0.0496,-0.0884 0.0496,-0.20492 v -0.29121 q 0,-0.11217 -0.0496,-0.19414 -0.0474,-0.0841 -0.13805,-0.12726 -0.0884,-0.0453 -0.21139,-0.0453 -0.1208,0 -0.2114,0.0453 -0.0906,0.0453 -0.14021,0.12942 -0.0474,0.082 -0.0474,0.19414 v 0.29336 q 0,0.11648 0.0474,0.20277 0.0496,0.0863 0.14021,0.13374 0.0906,0.0453 0.2114,0.0453 z m 0,-1.44955 q 0.10569,0 0.18335,-0.0431 0.0777,-0.0453 0.11864,-0.12942 0.0431,-0.0841 0.0431,-0.19845 v -0.18982 q 0,-0.11217 -0.0431,-0.1963 -0.041,-0.0841 -0.11864,-0.12942 -0.0777,-0.0453 -0.18335,-0.0453 -0.10354,0 -0.1812,0.0453 -0.0776,0.0453 -0.12079,0.12942 -0.041,0.0841 -0.041,0.19845 v 0.19198 q 0,0.11217 0.041,0.1963 0.0431,0.082 0.12079,0.12726 0.0777,0.0431 0.1812,0.0431 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 141.68059,144.12688 0.0518,0.0777 q -0.0625,0.10138 -0.16825,0.15315 -0.10354,0.0518 -0.22865,0.0518 -0.2114,0 -0.36671,-0.0971 -0.15531,-0.0971 -0.23943,-0.27611 -0.0841,-0.17904 -0.0841,-0.42063 v -0.23512 q 0,-0.27179 0.0928,-0.46377 0.0927,-0.19414 0.26747,-0.29552 0.17689,-0.10139 0.42495,-0.10139 0.24806,0 0.42494,0.10139 0.17689,0.10138 0.26748,0.29552 0.0928,0.19198 0.0928,0.46377 v 0.21139 q 0,0.17688 -0.0431,0.34298 -0.041,0.16393 -0.12512,0.35807 -0.0108,0.028 -0.0237,0.0561 -0.013,0.028 -0.0259,0.0561 l -0.58457,1.28346 h -0.4573 z m -0.25022,-0.11864 q 0.17257,0 0.26532,-0.11217 0.0949,-0.11217 0.0949,-0.31278 v -0.22649 q 0,-0.20277 -0.0949,-0.31493 -0.0928,-0.11217 -0.26532,-0.11217 -0.17257,0 -0.26748,0.11217 -0.0927,0.11216 -0.0927,0.31709 v 0.22649 q 0,0.20061 0.0927,0.31278 0.0949,0.11001 0.26748,0.11001 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 142.62971,145.24209 h 0.44651 v 0.67732 l -0.44651,0.48103 z m 0,-1.79901 h 0.44651 v 0.44652 h -0.44651 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 145.38646,145.72096 q -0.25238,0 -0.43789,-0.0928 -0.18335,-0.0927 -0.28474,-0.26747 -0.0992,-0.17473 -0.0992,-0.40985 v -0.28689 q 0,-0.20277 0.10138,-0.37102 0.10138,-0.17041 0.27826,-0.261 -0.15099,-0.0777 -0.23943,-0.21787 -0.0863,-0.14237 -0.0863,-0.30415 v -0.25669 q 0,-0.22434 0.0927,-0.38827 0.0927,-0.1661 0.26532,-0.25454 0.17472,-0.0906 0.40985,-0.0906 0.23727,0 0.40984,0.0906 0.17257,0.0884 0.26532,0.25454 0.0949,0.16393 0.0949,0.38827 v 0.25669 q 0,0.1661 -0.0906,0.30631 -0.0884,0.14021 -0.2416,0.21571 0.17904,0.0906 0.28258,0.261 0.10354,0.16825 0.10354,0.37102 v 0.28689 q 0,0.23512 -0.10138,0.40985 -0.0992,0.17472 -0.28474,0.26747 -0.18551,0.0928 -0.43788,0.0928 z m 0,-0.40985 q 0.12295,0 0.21139,-0.0475 0.0906,-0.0475 0.13805,-0.13374 0.0496,-0.0884 0.0496,-0.20492 v -0.29121 q 0,-0.11217 -0.0496,-0.19414 -0.0474,-0.0841 -0.13805,-0.12726 -0.0884,-0.0453 -0.21139,-0.0453 -0.1208,0 -0.2114,0.0453 -0.0906,0.0453 -0.14021,0.12942 -0.0474,0.082 -0.0474,0.19414 v 0.29336 q 0,0.11648 0.0474,0.20277 0.0496,0.0863 0.14021,0.13374 0.0906,0.0453 0.2114,0.0453 z m 0,-1.44955 q 0.10569,0 0.18335,-0.0431 0.0777,-0.0453 0.11864,-0.12942 0.0431,-0.0841 0.0431,-0.19845 v -0.18982 q 0,-0.11217 -0.0431,-0.1963 -0.041,-0.0841 -0.11864,-0.12942 -0.0777,-0.0453 -0.18335,-0.0453 -0.10354,0 -0.1812,0.0453 -0.0777,0.0453 -0.1208,0.12942 -0.041,0.0841 -0.041,0.19845 v 0.19198 q 0,0.11217 0.041,0.1963 0.0431,0.082 0.1208,0.12726 0.0777,0.0431 0.1812,0.0431 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 148.01593,144.36416 v 0.40121 h -1.27052 v -0.40121 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 149.35548,145.72096 q -0.38396,0 -0.58888,-0.20924 -0.20492,-0.21139 -0.20492,-0.59104 v -1.60271 q 0,-0.3818 0.20492,-0.59104 0.20492,-0.20923 0.58888,-0.20923 0.38612,0 0.58889,0.20923 0.20492,0.20924 0.20492,0.59104 v 1.60271 q 0,0.37965 -0.20492,0.59104 -0.20493,0.20924 -0.58889,0.20924 z m 0,-0.40337 q 0.18335,0 0.27611,-0.10354 0.0949,-0.10354 0.0949,-0.29337 v -1.60271 q 0,-0.19198 -0.0927,-0.29552 -0.0928,-0.10354 -0.27827,-0.10354 -0.18335,0 -0.2761,0.10354 -0.0928,0.10354 -0.0928,0.29552 v 1.60271 q 0,0.18983 0.0928,0.29337 0.0928,0.10354 0.2761,0.10354 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 151.44138,145.6886 h -0.42495 v -2.68556 l -0.46161,0.28473 v -0.44004 l 0.4422,-0.29552 h 0.44436 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 151.96986,145.3219 0.89088,-1.34818 q 0.11864,-0.18982 0.18119,-0.36023 0.0626,-0.17256 0.0626,-0.30846 v -0.006 q 0,-0.17904 -0.0884,-0.27395 -0.0863,-0.0971 -0.25238,-0.0971 -0.17473,0 -0.27395,0.1208 -0.0971,0.11864 -0.11001,0.34297 v 0.006 h -0.43789 v -0.006 q 0.0194,-0.28042 0.11864,-0.47455 0.0992,-0.1963 0.27179,-0.29552 0.17472,-0.10139 0.41632,-0.10139 0.25669,0 0.43357,0.0906 0.17688,0.0906 0.26748,0.26532 0.0927,0.17472 0.0927,0.4271 v 0.004 q 0,0.17688 -0.0733,0.38827 -0.0712,0.20924 -0.20708,0.43142 l -0.74419,1.15835 h 1.03108 v 0.40337 h -1.57898 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 155.31334,144.36416 v 0.40121 h -1.27052 v -0.40121 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 156.57954,145.72096 q -0.26747,0 -0.44867,-0.0928 -0.17904,-0.0927 -0.27395,-0.28257 -0.0927,-0.19198 -0.1057,-0.48319 v 0 h 0.42926 v 0 q 0.006,0.15747 0.0539,0.25669 0.0475,0.0971 0.13158,0.14453 0.0863,0.0475 0.21355,0.0475 0.17904,0 0.27611,-0.0971 0.0992,-0.0992 0.0992,-0.27395 v -0.2718 q 0,-0.19413 -0.0906,-0.30199 -0.0906,-0.10785 -0.25238,-0.10785 h -0.22002 v -0.40122 h 0.22002 q 0.13805,0 0.21355,-0.0884 0.0777,-0.0906 0.0777,-0.25022 v -0.27179 q 0,-0.151 -0.0841,-0.23297 -0.0841,-0.0841 -0.24159,-0.0841 -0.10786,0 -0.1812,0.0474 -0.0712,0.0475 -0.11432,0.14668 -0.041,0.0992 -0.0518,0.25454 v 0 h -0.42711 v 0 q 0.0151,-0.29121 0.1057,-0.48103 0.0928,-0.19198 0.26101,-0.28473 0.16825,-0.0928 0.42063,-0.0928 0.3516,0 0.54358,0.19198 0.19414,0.18983 0.19414,0.53496 v 0.25453 q 0,0.17041 -0.0992,0.31494 -0.0971,0.14452 -0.2761,0.23512 0.20276,0.0604 0.31493,0.22649 0.11217,0.1661 0.11217,0.412 v 0.2567 q 0,0.24375 -0.0949,0.41847 -0.0928,0.17472 -0.27395,0.26532 -0.17904,0.0906 -0.43142,0.0906 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 157.85006,144.83656 0.86068,-2.28219 h 0.43789 l -0.83479,2.2563 h 1.35033 v 0.3969 h -1.81411 z m 1.16267,-0.98795 h 0.41847 v 1.84215 h -0.41847 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 160.86566,145.72096 q -0.23944,0 -0.40769,-0.0906 -0.16825,-0.0906 -0.26101,-0.26963 -0.0927,-0.17904 -0.10569,-0.4422 v 0 h 0.42494 v 0 q 0.009,0.19629 0.0971,0.29767 0.0884,0.0992 0.25238,0.0992 0.17041,0 0.26316,-0.10786 0.0949,-0.10785 0.0949,-0.30199 v -0.55221 q 0,-0.19414 -0.0906,-0.30199 -0.0906,-0.10785 -0.25669,-0.10785 -0.11864,0 -0.20493,0.069 -0.0863,0.069 -0.12511,0.19414 h -0.38612 v -1.65448 h 1.43015 v 0.40337 h -1.0052 v 0.7291 q 0.0712,-0.069 0.16609,-0.10786 0.0949,-0.0388 0.19414,-0.0388 0.22218,0 0.37965,0.0971 0.15746,0.0949 0.23943,0.27827 0.082,0.18119 0.082,0.44004 v 0.55221 q 0,0.2567 -0.0928,0.44005 -0.0906,0.18335 -0.26532,0.28042 -0.17473,0.0949 -0.42279,0.0949 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 163.47357,144.36416 v 0.40121 h -1.27052 v -0.40121 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 164.73762,145.72096 q -0.24807,0 -0.42495,-0.0992 -0.17472,-0.10138 -0.26747,-0.2912 -0.0906,-0.18983 -0.0906,-0.45946 v -0.21139 q 0,-0.1812 0.041,-0.34514 0.041,-0.16609 0.12296,-0.36023 0.0129,-0.028 0.0259,-0.0561 0.0129,-0.0302 0.0259,-0.0582 l 0.59104,-1.28778 h 0.45945 l -0.73125,1.56388 -0.0539,-0.0777 q 0.0669,-0.10139 0.17041,-0.15747 0.10354,-0.0561 0.22649,-0.0561 0.21787,0 0.37318,0.0949 0.15746,0.0927 0.23727,0.27395 0.082,0.17903 0.082,0.43357 v 0.23512 q 0,0.26964 -0.0927,0.46377 -0.0928,0.19198 -0.26964,0.29337 -0.17688,0.10138 -0.42494,0.10138 z m 0,-0.40985 q 0.17472,0 0.26748,-0.11001 0.0949,-0.11001 0.0949,-0.30846 v -0.22434 q 0,-0.20708 -0.0971,-0.3214 -0.0971,-0.11433 -0.27395,-0.11433 -0.16609,0 -0.25885,0.11649 -0.0906,0.11432 -0.0906,0.3214 v 0.22434 q 0,0.19845 0.0928,0.30846 0.0949,0.10785 0.26532,0.10785 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 167.44691,142.93185 -0.75066,2.75675 h -0.44652 l 0.75498,-2.73302 h -0.67085 v 0.412 h -0.42494 v -0.81537 h 1.53799 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 169.23082,144.36416 v 0.40121 h -1.27052 v -0.40121 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 170.57684,145.72096 q -0.25238,0 -0.43789,-0.0928 -0.18335,-0.0927 -0.28474,-0.26747 -0.0992,-0.17473 -0.0992,-0.40985 v -0.28689 q 0,-0.20277 0.10138,-0.37102 0.10138,-0.17041 0.27826,-0.261 -0.15099,-0.0777 -0.23943,-0.21787 -0.0863,-0.14237 -0.0863,-0.30415 v -0.25669 q 0,-0.22434 0.0927,-0.38827 0.0927,-0.1661 0.26532,-0.25454 0.17472,-0.0906 0.40985,-0.0906 0.23727,0 0.40984,0.0906 0.17257,0.0884 0.26532,0.25454 0.0949,0.16393 0.0949,0.38827 v 0.25669 q 0,0.1661 -0.0906,0.30631 -0.0884,0.14021 -0.2416,0.21571 0.17904,0.0906 0.28258,0.261 0.10354,0.16825 0.10354,0.37102 v 0.28689 q 0,0.23512 -0.10138,0.40985 -0.0992,0.17472 -0.28474,0.26747 -0.18551,0.0928 -0.43788,0.0928 z m 0,-0.40985 q 0.12295,0 0.21139,-0.0475 0.0906,-0.0475 0.13805,-0.13374 0.0496,-0.0884 0.0496,-0.20492 v -0.29121 q 0,-0.11217 -0.0496,-0.19414 -0.0474,-0.0841 -0.13805,-0.12726 -0.0884,-0.0453 -0.21139,-0.0453 -0.1208,0 -0.2114,0.0453 -0.0906,0.0453 -0.14021,0.12942 -0.0474,0.082 -0.0474,0.19414 v 0.29336 q 0,0.11648 0.0474,0.20277 0.0496,0.0863 0.14021,0.13374 0.0906,0.0453 0.2114,0.0453 z m 0,-1.44955 q 0.10569,0 0.18335,-0.0431 0.0777,-0.0453 0.11864,-0.12942 0.0431,-0.0841 0.0431,-0.19845 v -0.18982 q 0,-0.11217 -0.0431,-0.1963 -0.041,-0.0841 -0.11864,-0.12942 -0.0777,-0.0453 -0.18335,-0.0453 -0.10354,0 -0.1812,0.0453 -0.0776,0.0453 -0.1208,0.12942 -0.041,0.0841 -0.041,0.19845 v 0.19198 q 0,0.11217 0.041,0.1963 0.0431,0.082 0.1208,0.12726 0.0777,0.0431 0.1812,0.0431 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 172.88491,144.12688 0.0518,0.0777 q -0.0626,0.10138 -0.16825,0.15315 -0.10354,0.0518 -0.22865,0.0518 -0.2114,0 -0.36671,-0.0971 -0.15531,-0.0971 -0.23943,-0.27611 -0.0841,-0.17904 -0.0841,-0.42063 v -0.23512 q 0,-0.27179 0.0928,-0.46377 0.0927,-0.19414 0.26747,-0.29552 0.17688,-0.10139 0.42495,-0.10139 0.24806,0 0.42494,0.10139 0.17688,0.10138 0.26748,0.29552 0.0928,0.19198 0.0928,0.46377 v 0.21139 q 0,0.17688 -0.0431,0.34298 -0.041,0.16393 -0.12511,0.35807 -0.0108,0.028 -0.0237,0.0561 -0.0129,0.028 -0.0259,0.0561 l -0.58457,1.28346 h -0.4573 z m -0.25022,-0.11864 q 0.17257,0 0.26532,-0.11217 0.0949,-0.11217 0.0949,-0.31278 v -0.22649 q 0,-0.20277 -0.0949,-0.31493 -0.0927,-0.11217 -0.26532,-0.11217 -0.17257,0 -0.26748,0.11217 -0.0927,0.11216 -0.0927,0.31709 v 0.22649 q 0,0.20061 0.0927,0.31278 0.0949,0.11001 0.26748,0.11001 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 108.58095,153.29868 h 0.91844 v 0.37006 h -0.91844 z m -2.0056,-1.42463 h 0.33746 l 1.05074,2.14558 -0.0537,0.0498 v -2.19543 h 0.36622 v 2.78599 h -0.33938 l -1.0469,-2.09572 0.0518,-0.0499 v 2.14557 h -0.36622 z m 2.46578,1.20797 q -0.2205,0 -0.3413,-0.1208 -0.11888,-0.1208 -0.11888,-0.33746 v -0.31637 q 0,-0.21284 0.11888,-0.3298 0.1208,-0.11696 0.3413,-0.11696 0.2205,0 0.33938,0.11888 0.11888,0.11696 0.11888,0.32979 v 0.31446 q 0,0.21666 -0.11888,0.33746 -0.11888,0.1208 -0.33938,0.1208 z m -0.002,-0.29337 q 0.0729,0 0.11121,-0.046 0.0384,-0.046 0.0384,-0.12847 v -0.30295 q 0,-0.0748 -0.0384,-0.11504 -0.0383,-0.0422 -0.11121,-0.0422 -0.0709,0 -0.10929,0.0422 -0.0364,0.0422 -0.0364,0.11888 v 0.29911 q 0,0.0844 0.0364,0.13038 0.0384,0.0441 0.10929,0.0441 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 111.03714,154.67154 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 112.51738,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16601"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 113.99761,154.67154 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16603"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 115.47785,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 116.95808,154.67154 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16607"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 118.43832,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 119.91855,154.67154 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 121.39879,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 122.87902,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16615"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 124.35926,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 125.83949,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 127.31973,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16621"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 128.79996,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16623"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 130.28019,154.67154 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 131.76043,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 133.24066,154.67154 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 134.7209,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 136.20113,154.67154 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 137.14066,154.69072 q -0.21859,0 -0.37389,-0.0844 -0.15531,-0.0844 -0.23776,-0.24351 -0.0824,-0.16106 -0.0824,-0.38731 v -0.62891 q 0,-0.22434 0.0824,-0.38157 0.0824,-0.15914 0.23776,-0.24159 0.1553,-0.0844 0.37389,-0.0844 0.21667,0 0.37197,0.0844 0.15531,0.0825 0.23585,0.24159 0.0805,0.15723 0.0805,0.38157 v 0.63466 q 0,0.22433 -0.0805,0.38348 -0.0805,0.15914 -0.23585,0.24351 -0.1553,0.0824 -0.37197,0.0824 z m -0.002,-0.36239 q 0.14764,0 0.23009,-0.092 0.0824,-0.094 0.0824,-0.2646 v -0.6174 q 0,-0.16682 -0.0824,-0.25885 -0.0824,-0.092 -0.23009,-0.092 -0.14956,0 -0.232,0.092 -0.0825,0.092 -0.0825,0.25885 v 0.6174 q 0,0.16873 0.0825,0.26269 0.0824,0.094 0.232,0.094 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 138.49818,152.7714 h 0.37773 v 1.89056 h -0.37773 z m -0.46209,-0.0997 h 1.30191 v 0.34897 h -1.30191 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 140.93328,154.67154 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 142.41352,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 143.89375,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 145.37399,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 146.85422,154.67154 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 148.33445,154.67154 v 0.35664 H 146.929 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 149.81469,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 151.29492,154.67154 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 152.77516,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 154.25539,154.67154 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 155.73563,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 157.21586,154.67154 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 158.6961,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 160.17633,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 161.65657,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 163.1368,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 164.61704,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 166.09727,154.67154 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 167.5775,154.67154 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 169.05774,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 170.53798,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 172.01821,154.67154 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16681"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 107.47269,156.99122 h 0.37581 v 1.99026 h -0.37581 z m -1.01047,0 h 0.37773 v 1.99026 h -0.37773 z m 0.23009,0.8379 h 0.99705 v 0.34897 h -0.99705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 109.33066,157.61821 q 0,-0.15531 -0.0844,-0.2416 -0.0825,-0.0863 -0.23392,-0.0863 -0.11121,0 -0.19558,0.0518 -0.0844,0.0518 -0.12655,0.14572 l -0.3202,-0.094 q 0.0537,-0.20708 0.2205,-0.32021 0.16873,-0.11504 0.41991,-0.11504 0.21667,0 0.37006,0.0786 0.15339,0.0767 0.232,0.22242 0.0805,0.14573 0.0805,0.35089 v 1.37094 h -0.36238 z m -0.42183,1.39203 q -0.30487,0 -0.45634,-0.14572 -0.15148,-0.14572 -0.15148,-0.43909 0,-0.31637 0.15915,-0.47359 0.16106,-0.15723 0.48318,-0.15723 h 0.40457 l 0.0268,0.3202 h -0.4295 q -0.14381,0 -0.21475,0.0767 -0.0709,0.0767 -0.0709,0.23392 0,0.1323 0.0786,0.1975 0.0786,0.0652 0.23776,0.0652 0.17831,0 0.26652,-0.0614 0.0882,-0.0633 0.0882,-0.19174 l 0.0403,0.23009 q -0.0268,0.11696 -0.0863,0.19366 -0.0594,0.0767 -0.15339,0.11504 -0.094,0.0364 -0.22242,0.0364 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 113.12711,157.61821 h 0.91844 v 0.37006 h -0.91844 z m -2.0056,-1.42463 h 0.33746 l 1.05074,2.14557 -0.0537,0.0499 v -2.19542 h 0.36623 v 2.78598 h -0.33938 l -1.04691,-2.09572 0.0518,-0.0498 v 2.14557 h -0.36622 z m 2.46578,1.20796 q -0.2205,0 -0.3413,-0.1208 -0.11888,-0.12079 -0.11888,-0.33746 v -0.31637 q 0,-0.21283 0.11888,-0.32979 0.1208,-0.11696 0.3413,-0.11696 0.2205,0 0.33938,0.11887 0.11888,0.11697 0.11888,0.3298 v 0.31445 q 0,0.21667 -0.11888,0.33746 -0.11888,0.1208 -0.33938,0.1208 z m -0.002,-0.29336 q 0.0729,0 0.11121,-0.046 0.0384,-0.046 0.0384,-0.12847 v -0.30295 q 0,-0.0748 -0.0384,-0.11504 -0.0383,-0.0422 -0.11121,-0.0422 -0.0709,0 -0.10929,0.0422 -0.0364,0.0422 -0.0364,0.11888 v 0.29911 q 0,0.0844 0.0364,0.13039 0.0384,0.0441 0.10929,0.0441 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 115.5833,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 117.06354,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 118.54377,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 120.02401,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 121.50424,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 122.98448,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 124.46471,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16701"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 125.94495,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 127.42518,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 128.90542,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 130.38565,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 131.86589,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 133.34612,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 134.82636,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 136.30659,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 137.24612,159.01024 q -0.21859,0 -0.3739,-0.0844 -0.15531,-0.0844 -0.23776,-0.24351 -0.0824,-0.16107 -0.0824,-0.38732 v -0.62891 q 0,-0.22433 0.0824,-0.38156 0.0825,-0.15915 0.23776,-0.24159 0.15531,-0.0844 0.3739,-0.0844 0.21666,0 0.37197,0.0844 0.15531,0.0824 0.23584,0.24159 0.0805,0.15723 0.0805,0.38156 v 0.63466 q 0,0.22434 -0.0805,0.38348 -0.0805,0.15915 -0.23584,0.24351 -0.15531,0.0825 -0.37197,0.0825 z m -0.002,-0.36239 q 0.14764,0 0.23009,-0.092 0.0824,-0.094 0.0824,-0.2646 v -0.61741 q 0,-0.16681 -0.0824,-0.25885 -0.0824,-0.092 -0.23009,-0.092 -0.14956,0 -0.23201,0.092 -0.0824,0.092 -0.0824,0.25885 v 0.61741 q 0,0.16873 0.0824,0.26268 0.0824,0.094 0.23201,0.094 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 138.60364,157.09092 h 0.37773 v 1.89056 h -0.37773 z m -0.4621,-0.0997 h 1.30192 v 0.34896 h -1.30192 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 141.03874,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 142.51897,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 143.99921,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 145.47944,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 146.95968,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 148.43991,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 149.92015,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 151.40038,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 152.88062,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 154.36085,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 155.84108,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 157.32132,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 158.80155,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 160.28179,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 161.76202,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 163.24226,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 164.72249,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 166.20273,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 167.68296,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 169.1632,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 170.64343,158.99107 v 0.35663 h -1.40545 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 172.12367,158.99107 v 0.35663 h -1.40546 v -0.35663 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path16765"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      stroke: "#074e9c",
      strokeWidth: 0.462641,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 105.21997,148.11665 h 68.12",
    id: "path59798-7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStamp);
export default __webpack_public_path__ + "static/media/stamp.7116bb39fc330c4cd4b204ac3691dc27.svg";
export { ForwardRef as ReactComponent };